<template>
  <div class="ae-basic-from">
    <el-form
      v-if="isFba"
      :disabled="!isEdit"
      class="section"
      style="flex-direction: row;"
    >
      <span style="display: flex;align-items: center;width: 64px">
        {{ $t('FbaJob.ValueAddedServices') }}
      </span>
      <el-checkbox-group v-model="selectedLocalAddedService" no="selectedLocalAddedService" @change="addedServiceChangeHandler">
        <el-checkbox
          v-for="item in localAddedService"
          :key="item.code"
          :label="item.code"
          style="margin-left: 8px;margin-right: 8px"
          no="localAddedService"
          @change="val => singleAddedServiceChangeHandler(val, item)"
        >
          {{ item.chineseName }}
        </el-checkbox>
      </el-checkbox-group>
      <el-checkbox v-if="isAeBooking" v-model="job.destinationPortService" style="margin-left: 8px;margin-right: 8px" no="destinationPortService">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
    </el-form>
    <el-form ref="basicForm" :disabled="viewStatus" style="display: flex;" label-position="right" label-width="100px">
      <div class="fit-content">
        <div style="display: flex">
          <div class="section form-column">
            <el-form-item :label="$t('SeaExport.JobNo')">
              <el-input v-model="job.jobNo" no="1" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperateType')">
              <cargo-advance-select
                no="2"
                :clearable="false"
                filterable
                :select-type="selectTypeNames.local_cache_AirExportConstants$BUSINESS_MODELS"
                :default-value="job.operateType"
                :disabled="!operateTypeEnable"
                :class="importDifferenceField.operateType ? 'red-border' : ''"
                @parentCallBack="p => {pm.operateTypeChangeHandler(p)}"
              />
            </el-form-item>
            <template v-if="isZY">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                  filterable
                  no="allowSaleProduct"
                  clearable
                  :data-filter-function="p => {
                    if (!p.statusEnabled) {
                      return false
                    }
                    return isFba ? p.fbaAir : p.airExportEnabled
                  }"
                  :default-value="this.job.saleProductCode || ''"
                  @parentCallBack="p => {this.job.saleProductCode = p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                  no="fullOrInside"
                  clearable
                  :default-value="this.job.fullOrInside || ''"
                  @parentCallBack="p => {this.job.fullOrInside = p.value}"
                />
              </el-form-item>
            </template>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.ConsignationCompany') }}</span>
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageB"
                  no="3"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <img
                    :class="job.customerId&&viewStatus?'':'not-click'"
                    :src="sopPic"
                    width="18"
                    height="28"
                    class="sop-img"
                    style="padding: 5px 0;vertical-align: bottom; cursor: pointer"
                    @click="pm.sopChangeCustomerIdHandler()"
                  >
                </el-tooltip>
                <el-tooltip
                  v-show="showWarningImageB"
                  :content="warningImageBTip"
                  placement="right-end"
                >
                  <i
                    class="el-icon-warning red"
                    style="cursor: pointer"
                  />
                </el-tooltip>
                <cargo-sales-company-select
                  v-if="!isFba"
                  ref="customerSelect"
                  no="4"
                  class="shipper-selector"
                  popper-class="shipper-selector-popper"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{customer:true,active:true,companyLob:'airExport'}"
                  :default-value="job.customerId||''"
                  :check-credit="true"
                  :disabled="!customerEnabled"
                  placeholder=" "
                  :style="{width: (showWarningImageB||sopImageB ) ?'180px':'200px'}"
                  :job="job"
                  :class="importDifferenceField.customerId ? 'red-border' : ''"
                  @parentCallBack="p=>{customerIdChange2ContractHandler(p)}"
                />
                <cargo-company-select
                  v-if="isFba"
                  ref="customerSelect"
                  no="customerId"
                  class="shipper-selector"
                  popper-class="shipper-selector-popper"
                  :method-params="{customer:true,companyLob:'airExport',active:true, fba:true}"
                  :check-credit="true"
                  :job="job"
                  :default-value="job.customerId||''"
                  :disabled="!customerEnabled"
                  :data-filter-function="fbaCustomerIdFilter"
                  placeholder=" "
                  :style="{width: (showWarningImageB||sopImageB ) ?'180px':'200px'}"
                  @change="p=>{customerIdChange2ContractHandler(p);clearPoNo()}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerProperty')">
              <el-tooltip :content="customerTip" placement="bottom">
                <span
                  v-show="customerLevel.customerName"
                  style="color:#FD9A14"
                >LV{{ customerLevel.level }}</span>
                <span
                  v-show="customerLevel.customerName"
                  style="color:#D3A73B"
                >&nbsp;{{ customerLevel.customerName }}</span>
                <span v-show="contractStatusLabel" style="color:red">&nbsp;({{ contractStatusLabel }})</span>
                <span v-show="advancePaymentLabel" style="color:firebrick">&nbsp;({{ advancePaymentLabel }})</span>
                <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
                  <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
                </span>
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceipt')">
              <el-input
                v-model="job.dispatchingPlace"
                no="dispatchingPlace"
                :class="importDifferenceField.dispatchingPlace ? 'red-border' : ''"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.LoadingPort') }}</span>
              <div style="display: flex;justify-content: space-between">
                <el-input no="5" :value="loading3Code" style="width:60px;margin-right: 5px;" :disabled="true" />
                <cargo-advance-select
                  ref="loadingPortCode"
                  no="6"
                  filterable
                  :select-type="selectTypeNames.basic_data_Airport"
                  :default-value="job.loadingPortCode"
                  style="flex:1"
                  tag-name="englishName"
                  :disabled="!!job.lclMasterUuid"
                  placeholder=" "
                  :class="importDifferenceField.loadingPortCode ? 'red-border' : ''"
                  @parentCallBack="p=>{pm.loadingPortCodeChange(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfDestination') }}</span>
              <div style="display: flex;justify-content: space-between">
                <el-input no="7" :value="destination3Code" style="width:60px;margin-right: 5px;" :disabled="true" />
                <cargo-advance-select
                  no="8"
                  filterable
                  :select-type="selectTypeNames.basic_data_Airport"
                  :default-value="job.destinationPortCode"
                  :disabled="!!job.lclMasterUuid"
                  placeholder=" "
                  style="flex:1"
                  :class="importDifferenceField.destinationPortCode ? 'red-border' : ''"
                  @parentCallBack="p=>{pm.destinationPortCodeChange(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FinalPlaceOfDelivery')">
              <div style="display: flex;justify-content: space-between">
                <el-input v-model="job.destinationPlace" :class="importDifferenceField.destinationPlace ? 'red-border' : ''" no="9" @input="val=>pm.destinationPlaceChange(val)" />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Airline')">
              <el-input v-model="vesselLine" no="10" :disabled="true" />
            </el-form-item>
            <el-form-item label="">
              <div style="display: flex;justify-content: space-between">
                <el-checkbox v-model="job.transfering" no="11">{{ $t('SeaExport.Transit') }}</el-checkbox>
                <el-button no="12" :disabled="viewStatus || (!viewStatus && !job.transfering)" type="primary" @click="setTransferingHandler">{{ $t('SeaExport.EnterTransitInfo') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <div style="display: flex;justify-content: space-between">
                <cargo-advance-select
                  no="13"
                  :clearable="false"
                  filterable
                  :select-type="selectTypeNames.local_cache_CargoSource"
                  :default-value="job.cargoSource"
                  :fields="['chineseName']"
                  :class="importDifferenceField.cargoSource ? 'red-border' : ''"
                  @parentCallBack="p=>{pm.cargoSourceChangeHandler(p)}"
                />
              </div>
            </el-form-item>
            <!--产品服务-->
            <el-form-item :label="$t('SeaExport.ServiceProduct')">
              <div style="display: flex;justify-content: space-between">
                <cargo-advance-select
                  no="145"
                  :clearable="false"
                  filterable
                  :select-type="selectTypeNames.basic_data_AirServiceProduct"
                  callback-method-type="value"
                  :default-value="job.serviceProduct"
                  :callback-params="{key:'serviceProduct'}"
                  @parentCallBack="setJobSelectValue"
                />
              </div>
            </el-form-item>
            <!--航线产品-->
            <el-form-item :label="$t('CargoMsg.Cargo_AirlineProductCode')">
              <div style="display: flex;justify-content: space-between">
                <cargo-advance-select
                  no="airlineProductUuid"
                  filterable
                  :static-options="airlineProductDownList"
                  :method-params="{active:true}"
                  tag-value="uuid"
                  tag-name="name"
                  :filter-tag-names="['name']"
                  :static-component="new AutoComplete()"
                  callback-method-type="value"
                  :default-value="job.airlineProductUuid"
                  :callback-params="{key:'airlineProductUuid'}"
                  @parentCallBack="setJobSelectValue"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                no="14"
                filterable
                :select-type="selectTypeNames.basic_data_CutomJobType"
                :method-params="{type:job.lob}"
                :default-value="job.customJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="customJobTypeList"
                @parentCallBack="p=>{job.customJobType=p.value;oncustomJobTypeChange(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.AppraisalCategory')">
              <cargo-advance-select
                no="146"
                filterable
                :select-type="selectTypeNames.basic_data_AppraisalCategory"
                :default-value="job.appraisalCategory"
                placeholder=" "
                @parentCallBack="p=>{job.appraisalCategory=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="job.customJobType && secondaryCustomJobTypeList.length > 0" :label="$t('CargoMsg.Cargo_Grade')">
              <cargo-advance-select
                ref="secondaryCustomJobType"
                no="secondaryCustomJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :cache="false"
                :default-value="job.secondaryCustomJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="secondaryCustomJobTypeList"
                @parentCallBack="p=>{job.secondaryCustomJobType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingAgent')">
              <cargo-advance-select
                no="15"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{localAgent:true,active: true}"
                :default-value="job.localAgent||''"
                placeholder=" "
                :class="importDifferenceField.localAgent ? 'red-border' : ''"
                @parentCallBack="p=>{pm.localAgentChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DestinationAgent')">
              <div style="display: flex;align-items: center">
                <el-tooltip v-show="showWarningImageC" :content="warningImageCTip" placement="right-end">
                  <i
                    class="el-icon-warning"
                    style="color:red"
                  />
                </el-tooltip>
                <cargo-advance-select
                  no="16"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{overseaAgent:true, active: true}"
                  :default-value="job.destinationAgent||''"
                  tag-name="englishName"
                  placeholder=" "
                  :class="importDifferenceField.destinationAgent ? 'red-border' : ''"
                  @parentCallBack="p=>{pm.destinationAgentChangeHandler(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item v-if="job.cargoSource === 'NC'">
              <span slot="label" class="blue">{{ $t('SeaExport.NominatedAgent') }}</span>
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageA"
                  no="17"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <div>
                    <img
                      :class="job.designationAgent&&viewStatus?'':'not-click'"
                      :src="sopPic"
                      width="18"
                      height="28"
                      class="sop-img"
                      style="padding: 5px 0;cursor: pointer"
                      no="designationAgent"
                      @click="pm.sopChangeBookingAgentHandler()"
                    >
                  </div>
                </el-tooltip>
                <el-tooltip
                  v-show="showWarningImageA"
                  :content="warningImageATip"
                  placement="right-end"
                >
                  <i class="el-icon-warning" style="color:red; cursor: pointer" />
                </el-tooltip>
                <cargo-advance-select
                  no="18"
                  class="designation-agent-selector"
                  popper-class="designation-agent-selector-popper"
                  :select-type="selectTypeNames.basic_data_Company"
                  :disabled="!designationAgentEnabled"
                  :method-params="{designationAgent:true,active:true}"
                  :check-credit="true"
                  :default-value="job.designationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  placeholder=" "
                  :class="importDifferenceField.designationAgent ? 'red-border' : ''"
                  @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillExchangeAgent')">
              <cargo-company-select
                no="exChangeAgent"
                :disabled="!job.dischargingPortDoor"
                :method-params="{bookingAgent:true,active:true}"
                :default-value="job.exChangeAgent||''"
                :class="importDifferenceField.exChangeAgent ? 'red-border' : ''"
                @change="onExChangeAgentChange"
              />
            </el-form-item>
            <el-form-item v-if="bookingAgentVisible" :label="$t('SeaExport.BookingAgent')">
              <cargo-advance-select
                no="19"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true, active: true}"
                :default-value="job.bookingAgent||''"
                :disabled="!bookingAgentEnabled"
                placeholder=" "
                :class="importDifferenceField.bookingAgent ? 'red-border' : ''"
                @parentCallBack="p => {pm.bookingAgentChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocCutOffDate')">
              <el-date-picker
                ref="fileCutoff"
                v-model="job.fileCutoff"
                no="20"
                :disabled="!!job.lclMasterUuid"
                clearable
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                style="width: 100%"
                :class="importDifferenceField.fileCutoff ? 'red-border' : ''"
                @blur="()=> { handleBlur('fileCutoff', null, true, false, job) }"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBillNo')">
              <el-checkbox v-model="job.express" style="margin-right: 2px" no="122" @change="expressChangeHandler">{{ $t('SeaExport.ExpressInfo') }}</el-checkbox>
              <el-input v-if="job.express" v-model="job.mbl" no="21" style="width: 130px;" @change="mblChange" />
              <mawb-no-input v-show="!job.express" ref="mawbNoInput" v-model="job.mbl" no="22" :editable="isEditablemawbNoInput" @change="mblChangeEvent" @changeCallback="mblCheckHandler(true)" />
            </el-form-item>
            <el-form-item>
              <el-button no="23" :disabled="!propertiesEnabled.selectBtnEnabled" type="primary" @click="openMAWBHandler">{{ $t('SeaExport.Select') }}</el-button>
              <el-button no="24" :disabled="!propertiesEnabled.newConsoleBtnEnabled" type="primary" @click="newConsoleHandler">{{ $t('SeaExport.New') }}</el-button>
            </el-form-item>
            <el-form-item>
              <el-button no="25" :disabled="!propertiesEnabled.attachBtnEnabled" type="primary" @click="attachMAWBHandler">{{ $t('SeaExport.Add3') }}</el-button>
              <el-button no="26" :disabled="!propertiesEnabled.deattachBtnEnabled" type="primary" @click="deattachMAWBHandler">{{ $t('SeaExport.Separate') }}</el-button>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SoNo')">
              <so-no-input v-model="job.jobSoNo" no="27" :disabled="viewStatus" />
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="job.predictionOperation" no="28">{{ $t('SeaExport.PreAlertOperation') }}</el-checkbox>
            </el-form-item>
          </div>
          <div class="section form-column">
            <el-form-item v-if="!isFba && !isAeBooking" :label="$t('SeaExport.PortOfDestinationServices')">
              <el-checkbox
                v-model="job.dischargingPortDoor"
                no="dischargingPortDoor"
                style="display: block;"
              >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
              </el-checkbox>
              <el-checkbox
                v-model="job.usCustomsClearance"
                no="usCustomsClearance"
                style="display: block;"
              >{{ $t('queryJob.UsCustomsClearance') }}
              </el-checkbox>
              <el-checkbox
                v-model="job.destPortCustomsClearance"
                no="destPortCustomsClearance"
                style="display: block;"
              >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContactPerson')" label-width="120px">
              <div style="display: flex;justify-content: space-between">
                <el-select v-model="job.customerContact" no="29" :class="importDifferenceField.customerContact ? 'red-border' : ''" filterable :allow-create="true" placeholder=" ">
                  <el-option
                    v-for="(item,index) in contactList"
                    :key="index"
                    :label="item.contactPerson"
                    :value="item.contactPerson"
                  />
                </el-select>
                <el-link v-show="!isShowContactPersonDetail" no="30" style="width: 80px" @click="showContactsInfoDialog=true">{{ $t('SeaExport.Detail') }}</el-link>
              </div>
            </el-form-item>
            <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Tel')" label-width="120px">
              <el-input v-model="job.contactTelephone" :class="importDifferenceField.contactTelephone ? 'red-border' : ''" no="31" />
            </el-form-item>
            <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Fax')" label-width="120px">
              <el-input v-model="job.contactFax" :class="importDifferenceField.contactFax ? 'red-border' : ''" no="32" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ArrivalMethod')" label-width="120px">
              <cargo-advance-select
                ref="loadingTerm"
                no="33"
                :clearable="false"
                filterable
                :select-type="selectTypeNames.local_cache_AirExportConstants$SUFFY_TYPES"
                callback-method-type="value"
                :default-value="job.loadingTerm"
                :fields="['chineseName']"
                :tag-name="isZh ? 'chineseName' : 'englishName'"
                :callback-params="{key:'loadingTerm'}"
                placeholder=" "
                :class="importDifferenceField.loadingTerm ? 'red-border' : ''"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item v-if="!isFba && isAeBooking" :label="$t('SeaExport.PortOfDestinationServices')">
              <el-checkbox
                v-model="job.dischargingPortDoor"
                no="dischargingPortDoor"
                style="display: block;"
                @change="dischargingPortDoorClick"
              >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
              </el-checkbox>
              <el-checkbox
                v-model="job.usCustomsClearance"
                no="usCustomsClearance"
                style="display: block;"
              >{{ $t('queryJob.UsCustomsClearance') }}
              </el-checkbox>
              <el-checkbox
                v-model="job.destPortCustomsClearance"
                no="destPortCustomsClearance"
                style="display: block;"
              >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item v-if="isFba && isAeBooking && job.destinationPortService" :label="$t('SeaExport.PortOfDestinationServices')">
              <el-checkbox-group v-model="selectedPodAddedService" no="123" @change="addedServiceChangeHandler">
                <el-checkbox
                  v-for="item in podAddedService"
                  :key="item.code"
                  :label="item.code"
                  style="display:block"
                  no="124"
                  @change="val => singleAddedServiceChangeHandler(val, item)"
                >
                  {{ item.chineseName }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.quotationNum')" label-width="120px">
              <el-input no="34" :value="job.quotationNo" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BookingProperty')" label-width="120px">
              <cargo-advance-select
                no="35"
                filterable
                :clearable="false"
                :select-type="selectTypeNames.local_cache_BookingTerm"
                :default-value="job.bookingTerm"
                :disabled="!propertiesEnabled.bookingTermEnabled"
                :fields="['chineseName']"
                :class="importDifferenceField.bookingTerm ? 'red-border' : ''"
                @parentCallBack="p => {pm.bookingTermChangeHandler(p)}"
              />
            </el-form-item>
            <!-- 报关方式-->
            <el-form-item :label="$t('SeaExport.CustomsDeclarationMethod')" label-width="120px">
              <cargo-advance-select
                v-if="!isFba"
                no="36"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:2}"
                tag-value="serialNum"
                filterable
                :default-value="job.customClaim"
                :class="importDifferenceField.customClaim ? 'red-border' : ''"
                @parentCallBack="p=>{job.customClaim=p.value}"
              />
              <cargo-advance-select
                v-if="isFba"
                no="customsMethodPol"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:0}"
                filterable
                :clearable="false"
                :default-value="fbaJob.customsMethodPol"
                @parentCallBack="p=>{fbaJob.customsMethodPol=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('AirExport.CustomsClearanceMethod')" label-width="120px">
              <cargo-advance-select
                no="customsMethodPod"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:1}"
                filterable
                :clearable="false"
                :default-value="fbaJob.customsMethodPod"
                @parentCallBack="p=>{fbaJob.customsMethodPod=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="Number(job.customClaim) === 1" :label="$t('SeaExport.CustomsDeclarationType')" label-width="120px">
              <cargo-advance-select
                no="37"
                filterable
                :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                :default-value="job.customsClaim2 || 0"
                @parentCallBack="p=>{job.customsClaim2=p.value;job.customsDeclarationType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')" label-width="120px">
              <cargo-advance-select
                no="38"
                filterable
                :clearable="false"
                :select-type="selectTypeNames.basic_data_TradeTerm"
                callback-method-type="value"
                :default-value="job.tradeTerm"
                :class="importDifferenceField.tradeTerm ? 'red-border' : ''"
                :callback-params="{key:'tradeTerm'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.StatusOfCustomsDeclaration')" label-width="120px">
              <cargo-advance-select
                no="39"
                filterable
                :disabled="false"
                :select-type="selectTypeNames.local_cache_SystemConstants$DECLARE_CUSTOMS_STATE"
                :default-value="job.declareCustomsState || ''"
                :tag-name="isZh?'chineseName':'englishName'"
                :fields="['chineseName']"
                :class="importDifferenceField.declareCustomsState ? 'red-border' : ''"
                @parentCallBack="p=>{job.declareCustomsState=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')" label-width="120px">
              <cargo-advance-select
                no="40"
                filterable
                :clearable="false"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                callback-method-type="value"
                :default-value="job.incoTerm"
                :callback-params="{key:'incoTerm'}"
                placeholder=" "
                :class="importDifferenceField.incoTerm ? 'red-border' : ''"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineCompany')" label-width="120px">
              <cargo-advance-select
                no="41"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{airCmp:true, companyLob:'airExport',active:true}"
                :default-value="job.carrierId||''"
                :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
                :fields="['shortName', 'chineseName']"
                :disabled="!airlineCompanyEnabled"
                placeholder=" "
                :class="importDifferenceField.carrierId ? 'red-border' : ''"
                @parentCallBack="p => {pm.airlineCompanyChangeHandler(p.value||0);pm.airlineCompanyChange(p.value||0);airlineCompanyCheckHandler(p.value||0)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Flight')" label-width="120px">
              <el-input v-model="job.voyageFlight" no="42" :class="importDifferenceField.voyageFlight ? 'red-border' : ''" :disabled="!flightEnabled" @change="voyageFlightCheckHandler" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationDate')" label-width="120px">
              <el-date-picker
                v-model="job.customsDate"
                no="43"
                type="date"
                value-format="yyyy-MM-dd"
                clearable
                style="width: 100%"
                :class="importDifferenceField.customsDate ? 'red-border' : ''"
              />
            </el-form-item>
            <el-form-item label-width="120px">
              <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  ref="etd"
                  :value="job.etd"
                  no="44"
                  :disabled="!!job.lclMasterUuid || provisionEtdLocked"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  clearable
                  style="flex: 1; width:170px; margin-right: 5px"
                  :class="importDifferenceField.etd ? 'red-border' : ''"
                  @input="etdChange"
                  @blur="()=> { handleBlur('etd', etdChange, false, false, job) }"
                />
                <span>{{ job.sailingDay|filterWeek }}</span>
              </div>
              <span v-if="provisionEtdLocked" style="color: red; font-size: 12px;">(已计提校准不可修改)</span>
            </el-form-item>
            <el-form-item label-width="120px">
              <span slot="label">{{ $t('SeaExport.DateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  ref="eta"
                  v-model="job.eta"
                  no="45"
                  :disabled="!!job.lclMasterUuid"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  style="flex: 1; width:170px; margin-right: 5px"
                  :class="importDifferenceField.eta ? 'red-border' : ''"
                  clearable
                  @input="etaChange"
                  @blur="()=> { handleBlur('eta', etaChange, false, false, job) }"
                />
                <span>{{ job.etaSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>

            <el-form-item label-width="120px">
              <span slot="label">{{ $t('SeaExport.ActualDateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  ref="atd"
                  :value="job.atd"
                  no="46"
                  :disabled="!!job.lclMasterUuid"
                  style="flex: 1; width:170px; margin-right: 5px"
                  clearable
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  @input="atdChange"
                  @blur="()=> { handleBlur('atd', atdChange, false, false, job) }"
                />
                <span>{{ job.atdSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item label-width="120px">
              <span slot="label">{{ $t('SeaExport.ActualDateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  ref="ata"
                  v-model="job.ata"
                  no="47"
                  :disabled="!!job.lclMasterUuid"
                  style="flex: 1; width:170px; margin-right: 5px"
                  clearable
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  @input="ataChange"
                  @blur="()=> { handleBlur('ata', ataChange, false, false, job) }"
                />
                <span>{{ job.ataSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CategoryOfGoods')" label-width="120px">
              <cargo-advance-select
                no="48"
                :select-type="selectTypeNames.basic_data_CargoInformation"
                filterable
                :callback-params="{key:'cargoCode'}"
                :default-value="job.cargoCode"
                placeholder=" "
                :class="importDifferenceField.cargoCode ? 'red-border' : ''"
                @parentCallBack="txtCargoInformationChangeHandler"
              />
              <el-input v-model="job.cargoName" :class="importDifferenceField.cargoName ? 'red-border' : ''" :disabled="!job.cargoCode" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TransportSource')" label-width="120px">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_TransportSource"
                no="transportSource"
                :default-value="job.transportSource"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>job.transportSource=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ServiceStatisticalArea')" label-width="120px">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_StatisticArea"
                no="statisticArea"
                :default-value="job.statisticArea"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>job.statisticArea=item.value"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('SeaExport.Package')" label-width="120px">
              <cargo-packing-select
                no="packing"
                :default-value="job.packing"
                :callback-params="{}"
                placeholder=" "
                @change="p => {p.key = 'packing';setJobSelectValue(p)}"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('SeaExport.HsCode')" label-width="120px">
              <el-input v-model="job.hsCode" :class="importDifferenceField.hsCode ? 'red-border' : ''" no="hsCode" />
            </el-form-item>
            <el-form-item v-if="isFba" label-width="0">
              <div style="display: flex;justify-content: space-around">
                <el-checkbox v-model="fbaJob.electric" style="margin-right: 10px;margin-left: 20px;" no="125">{{ $t('AirExport.WithBattery') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.magnetic" style="margin-right: 10px;" no="126">{{ $t('AirExport.WithMagnet') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.powdery" style="margin-right: 10px;" no="127">{{ $t('AirExport.Powder') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.liquid" style="margin-right: 10px;" no="128">{{ $t('AirExport.Liquid') }}</el-checkbox>
              </div>
            </el-form-item>
            <!-- 集装器 -->
            <booking-air-uld-data-grid
              v-if="!job.lclMasterUuid && job.operateType !== 0"
              :value="airUlds"
              :is-edit="isEdit"
              :job="job"
              style="width: 100%"
            />
          </div>
          <div class="section form-column">
            <el-form-item label="">
              <div style="display: flex">
                <el-checkbox v-if="!isFba" v-model="job.virtualHBL" no="49">{{ $t('SeaExport.FormalHbl') }}</el-checkbox>
                <el-checkbox v-if="!isFba" v-model="job.itmService" no="50" style="margin-left: -20px">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
                <span
                  v-if="viewSource === 'AeBooking'"
                  id="Insure"
                  v-permission="['button_insurance_toInsure']"
                  type="primary"
                  :class="viewStatus?'el-button el-button--primary el-button--mini':'el-button el-button--primary el-button--mini is-disabled'"
                  style="min-width:46px!important;margin-left:15px"
                  no="129"
                  @click="()=>{if (viewStatus){pm.toInsure()}}"
                >{{ $t('SeaExport.Insure') }}
                </span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WarehouseNo')">
              <el-input
                v-model="job.warehouseNo"
                no="52"
                type="textarea"
                :rows="5"
                @dblclick.native="showWarehouseDialog"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_FrontEndWarehouseOperation')">
              <cargo-advance-select
                no="frontEndWarehouseOperation"
                :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
                :method-params="{dataType:1, deletionFlag: false, orderType: SystemConstants.AE.code}"
                filterable
                :clearable="true"
                :default-value="job.frontEndWarehouseOperation"
                @parentCallBack="p=>{job.frontEndWarehouseOperation=p.value}"
              />
            </el-form-item>
            <el-form-item
              :label="$t('Warehouse.WarehouseInState')"
              no="WarehouseState"
            >
              <el-select
                v-model="job.warehouseStatus"
                :disabled="true"
                :placeholder="$t('Message.PleaseSelect')"
                size="mini"
                no="130"
              >
                <el-option
                  v-for="(item,index) in WarehouseInState.WAREHOUSE_STATE"
                  :key="index"
                  :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_EstimatedWarehousingTime')">
              <el-date-picker
                ref="estimatedDateOfWarehousinge"
                v-model="job.estimatedDateOfWarehousinge"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                clearable
                no="131"
                :class="importDifferenceField.estimatedDateOfWarehousinge ? 'red-border' : ''"
                @change="changeEstimatedDateOfWarehousinge"
                @blur="()=> { handleBlur('estimatedDateOfWarehousinge', changeEstimatedDateOfWarehousinge, true, true, job) }"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ActualWarehousingTime')">
              <el-date-picker
                type="datetime"
                :disabled="true"
                :placeholder="$t('CargoMsg.Cargo_SyncWarehouseData')"
                :value="job.warehouseInDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                clearable
                no="132"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_EstimatedDeliveryTime')">
              <el-date-picker
                ref="estimatedDeliveryTime"
                v-model="job.estimatedDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                clearable
                no="133"
                :class="importDifferenceField.estimatedDeliveryTime ? 'red-border' : ''"
                @change="changeEstimatedDeliveryTime"
                @blur="()=> { handleBlur('estimatedDeliveryTime', changeEstimatedDeliveryTime, true, true, job) }"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ActualDeliveryTime')">
              <el-date-picker
                type="datetime"
                :disabled="true"
                :placeholder="$t('CargoMsg.Cargo_SyncWarehouseData')"
                :value="job.warehouseOutDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                clearable
                no="134"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CargoTerminalOperation')">
              <cargo-advance-select
                no="cargoTerminalOperation"
                :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
                :method-params="{dataType:0, deletionFlag: false}"
                filterable
                :clearable="true"
                :default-value="job.cargoTerminalOperation"
                @parentCallBack="p=>cargoTerminalOperationChange(p)"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_EstimatedDeliveryDate')">
              <el-date-picker v-model="job.estimatedDeliveryDate" :disabled="!isEdit || !job.cargoTerminalOperation" no="estimatedDeliveryDate" type="date" value-format="yyyy-MM-dd" clearable />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerReferenceNumber')">
              <cargo-input v-model="job.customerRefNo" no="53" :trim="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FirstLegNo')" :title="$t('SeaExport.FirstLegNoTips')">
              <el-input v-model="job.relatedJob2" no="54" />
            </el-form-item>
            <el-form-item label="KC No">
              <el-input v-model="job.kcNo" no="55" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ItemNo')" :class="poNoRed?'poNoClass':''">
              <el-input v-if="!openProjectConfig" v-model="job.poNo" no="56" />
              <cargo-project-select
                v-if="openProjectConfig"
                no="57"
                :default-value="job.poNo"
                :customer-id="job.customerId"
                :is-linked="isProjectLinkedCustomer"
                placeholder=" "
                @change="
                  p => {
                    job.poNo = p.value
                    job.projectName = p.projectName
                    changeProject()
                  }
                "
              />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectName')"
            >
              <el-input v-model="job.projectName" no="58" :disabled="true" />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectBatch')"
            >
              <el-input v-model="job.projectBatch" no="59" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
              <cargo-advance-select
                no="60"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :clearable="false"
                :default-value="job.paymentTermMBL"
                :class="importDifferenceField.paymentTermMBL ? 'red-border' : ''"
                @parentCallBack="p => {pm.paymentTermMBLChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HBLFreightClause')">
              <cargo-advance-select
                no="61"
                filterable
                :clearable="false"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                :default-value="job.paymentTermHBL"
                placeholder=" "
                :class="importDifferenceField.paymentTermHBL ? 'red-border' : ''"
                @parentCallBack="p => {pm.paymentTermHBLChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SpaceRquirement')">
              <el-input v-model="job.cabinReq" no="62" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OnBoardRequirements')">
              <el-input v-model="job.loadReq" no="63" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentationRequirements')">
              <el-input v-model="job.docReq" no="64" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoType')">
              <el-select v-model="job.cargoType" :class="importDifferenceField.cargoType ? 'red-border' : ''" filterable no="135" @change="onCargoTypeChagne">
                <el-option
                  v-for="(item,index) in cargoType4JobSelect"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OrderChannels')">
              <el-input
                v-model="job.salesChannel"
                :disabled="true"
                no="136"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ConsignationRelationNumber')">
              <el-input
                v-model="job.trustFromJob"
                :disabled="true"
                no="trustFromJob"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BusinessCommissionedRelationNumber')">
              <el-input
                v-model="job.relatedJob"
                :disabled="true"
                no="relatedJob"
              />
            </el-form-item>
            <el-form-item v-if="showChannelNo" :label="$t('SeaExport.ChannelNo')">
              <el-input v-model="job.channelNo" :disabled="true" no="137" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoSize')">
              <el-button
                no="GetGoodsInformation"
                :disabled="!isEdit"
                type="primary"
                @click="pm.getCargoInformation()"
              >
                {{ $t('SeaExport.GetGoodsInformation') }}
              </el-button>
              <el-tooltip
                effect="light"
                :content="$t('SeaExport.GetGoodsInformationTip')"
                placement="right-end"
                disabled
              >
                <i style="cursor:pointer;margin-left:4px;color:#1989fa;" class="el-icon-question" />
              </el-tooltip>
            </el-form-item>
            <el-form-item label="" class="auto-width">
              <el-input
                v-model="job.measurements"
                no="66"
                type="textarea"
                :rows="3"
                @change="p=>{pm.measurementsChangeHandler(p)}"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.CargoSize'),job.measurements,val=>{pm.doMeasurementsChangeHandler(val)})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SellingPrice')">
              <el-input v-model="job.selling" :disabled="job.sellingPriceLock || !isEdit" no="67" @blur="sellingOrBuyingChangeHandler" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BuyingPrice')">
              <el-input v-model="job.buying" :disabled="job.purchasePriceLock || !isEdit" no="68" @blur="sellingOrBuyingChangeHandler" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ProtocolType')">
              <cargo-advance-select
                no="69"
                filterable
                :clearable="false"
                :select-type="selectTypeNames.local_cache_SystemConstants$PROTOCOL_TYPES"
                callback-method-type="value"
                :default-value="job.protocolType || 'none'"
                :tag-name="isZh?'chineseName':'englishName'"
                :fields="['chineseName']"
                :callback-params="{key:'protocolType'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationRequirements')">
              <el-tooltip :content="job.operationContent" placement="left">
                <div slot="content" v-html="job.operationContent ? job.operationContent.replace(/[\n]/g,'</br>') : $t('SeaExport.NoData')" />
                <el-input
                  no="70"
                  :value="job.operationContent"
                  :placeholder="viewStatus ? '' : $t('SeaExport.DoubleClickToAddOperationRequirements')"
                  type="textarea"
                  :rows="4"
                  @dblclick.native="selectOperationReqDialog.value=job.operationContent;selectOperationReqDialog.visible=!viewStatus"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WoodOrNotWood')">
              <div style="display: flex;justify-content: space-between">
                <cargo-advance-select
                  no="147"
                  :clearable="false"
                  filterable
                  :select-type="selectTypeNames.local_cache_AirExportConstants$WOOD"
                  :default-value="job.wood"
                  :fields="['chineseName']"
                  @parentCallBack="onWoodOrNotWoodChagne"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HazardousGoodsOption')">
              <div style="display: flex;justify-content: space-between">
                <cargo-advance-select
                  no="148"
                  :clearable="false"
                  filterable
                  :select-type="selectTypeNames.local_cache_AirExportConstants$HAZARDOUS_GOODS_OPTION"
                  :default-value="job.hazardousGoodsOption"
                  :fields="['chineseName']"
                  @parentCallBack="onHazardousGoodsOptionChagne"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.handlingInformation')">
              <el-input
                v-model="job.handlingInformation"
                no="149"
                :readonly="true"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.handlingInformation'),job.handlingInformation,val=>{job.handlingInformation=val})"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('SeaExport.OperationTips')">
              <el-input
                v-model="job.operationTips"
                no="operationTips"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
          </div>
          <div class="section form-column">
            <el-form-item :label="$t('SeaExport.SalesCompany')">
              <el-input v-model="txtSalesOffice" :class="importDifferenceField.salesOffice ? 'red-border' : ''" no="71" :disabled="true" />
            </el-form-item>
            <el-form-item>
              <span slot="label" :class="job.cargoSource === 'NC' ? '': 'blue'">{{ $t('SeaExport.Sales') }}</span>
              <div style="display: flex;justify-content: space-between">
                <cargo-user-select
                  ref="sales"
                  no="72"
                  :disabled="!saleEnabled"
                  :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales',active:true}"
                  :default-value="job.sales||''"
                  :static-options="salesList"
                  :placeholder="salesPrompt||' '"
                  style="width: 130px;flex: 1"
                  :class="importDifferenceField.sales ? 'red-border' : ''"
                  @change="p=>{pm.salesChangeHandler(p);}"
                />&nbsp;
                <el-checkbox v-model="job.provisioned" no="73" style="margin-left: 5px" :disabled="true">{{ $t('SeaExport.Accrued') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="74"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="job.cargoSalesId||''"
                placeholder=" "
                :static-options="cargoSalesList"
                :class="importDifferenceField.cargoSalesId ? 'red-border' : ''"
                @change="p=>{job.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" :class="job.cargoSource === 'NC' ? '': 'blue'">{{ $t('SeaExport.SalesDepartment') }}</span>
              <cargo-department-new-select
                no="75"
                :disabled="!job.sales"
                :enables="true"
                :sales-id="Number(job.sales)"
                :office-id="Number(job.salesOffice)"
                :department-id="Number(job.salesDepartment)"
                :class="importDifferenceField.salesDepartment ? 'red-border' : ''"
                @change="p=>{pm.departmentChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-office-select
                no="76"
                :disabled="viewStatus || opOfficeDisabled"
                :office-id="Number(job.opOffice)"
                placeholder=" "
                :class="importDifferenceField.opOffice ? 'red-border' : ''"
                :is-regional-commission="isRegionalCommission"
                @change="p=>{pm.opOfficeChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}</span>
              <cargo-department-select
                no="77"
                :disabled="!opDeptEnabled"
                :enables="true"
                :office-id="Number(job.opOffice)"
                :department-id="Number(job.opDepartment)"
                placeholder=" "
                :class="importDifferenceField.opDepartment ? 'red-border' : ''"
                @change="p=>{job.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" :class="(pageSource === 'AeBookingVerify')?'':'blue'">{{ $t('SeaExport.Operation') }}</span>
              <cargo-user-select
                no="78"
                :method-params="{officeId:job.opOffice,category:'role',shape:'op'}"
                :default-value="job.op||''"
                :static-options="userPortRoleData.op"
                placeholder=" "
                :class="importDifferenceField.op ? 'red-border' : ''"
                @change="p=>{pm.opChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-office-select
                no="csrOffice"
                :disabled="true"
                :office-id="Number(job.csrOffice)"
                :class="importDifferenceField.csrOffice ? 'red-border' : ''"
                @change="p=>{job.csrOffice=p.value;job.csrDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Customer_Service') }}</span>
              <cargo-department-select
                no="csrDepartment"
                :office-id="Number(job.csrOffice)"
                :enables="true"
                :department-id="Number(job.csrDepartment)"
                :class="importDifferenceField.csrDepartment ? 'red-border' : ''"
                @change="p=>{job.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                no="79"
                :method-params="{category:'role',shape:'csr'}"
                :default-value="job.csr||''"
                placeholder=" "
                :static-options="userPortRoleData.csr"
                :class="importDifferenceField.csr ? 'red-border' : ''"
                @change="p=>{pm.csrChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-office-select
                no="dcOffice"
                :disabled="true"
                :office-id="Number(job.dcOffice)"
                :class="importDifferenceField.dcOffice ? 'red-border' : ''"
                @change="p=>{job.dcOffice=p.value;job.dcDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
              <cargo-department-select
                no="dcDepartment"
                :office-id="Number(job.dcOffice)"
                :enables="true"
                :department-id="Number(job.dcDepartment)"
                :class="importDifferenceField.dcDepartment ? 'red-border' : ''"
                @change="p=>{job.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select
                no="80"
                :method-params="{category:'role',shape:'doc'}"
                :default-value="job.dc||''"
                placeholder=" "
                :class="importDifferenceField.dc ? 'red-border' : ''"
                :static-options="userPortRoleData.doc"
                @change="p=>{pm.dcChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineOffice')">
              <cargo-office-select
                no="plannerOffice"
                :disabled="true"
                :office-id="Number(job.plannerOffice)"
                :class="importDifferenceField.plannerOffice ? 'red-border' : ''"
                @change="p=>{job.plannerOffice=p.value;job.plannerDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.AirlineDepartment') }}</span>
              <cargo-department-select
                no="plannerDepartment"
                :office-id="Number(job.plannerOffice)"
                :enables="true"
                :department-id="Number(job.plannerDepartment)"
                :class="importDifferenceField.plannerDepartment ? 'red-border' : ''"
                @change="p=>{job.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlinePerson2')">
              <cargo-user-select
                no="81"
                :method-params="{officeId:job.opOffice,category:'role',shape:'airline'}"
                :default-value="job.planner||''"
                placeholder=" "
                :class="importDifferenceField.planner ? 'red-border' : ''"
                :static-options="userPortRoleData.airline"
                @change="p=>{pm.plannerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                no="82"
                :method-params="{officeId:job.opOffice,category:'role',shape:'siteOp'}"
                :default-value="job.siteOP||''"
                placeholder=" "
                :static-options="userPortRoleData.siteOp"
                @change="p=>{pm.siteOpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <!--              <cargo-user-select-->
              <!--                :method-params="{category:'role',shape:'overseaOp'}"-->
              <!--                :default-value="job.overseaOp||''"-->
              <!--                @change="p=>{pm.overseaOpChangeHandler(p)}"-->
              <!--              />-->
              <cargo-user-select
                ref="overseaOp"
                no="83"
                :default-value="job.overseaOp||''"
                :method-params="{category:'role',shape:'overseaOp'}"
                :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
                :merge-load="true"
                placeholder=" "
                @change="p=>{job.overseaOp=p.value;pm.overseaOpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :disabled="viewStatus"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="job.userDefinedRoleId1||''"
                :merge-load="true"
                placeholder=" "
                :static-options="userPortRoleData.userDefinedRole1"
                @change="p=>{pm.userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :disabled="viewStatus"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="job.userDefinedRoleId2||''"
                :merge-load="true"
                placeholder=" "
                :static-options="userPortRoleData.userDefinedRole2"
                @change="p=>{pm.userDefinedRoleId2Handler(p)}"
              />
            </el-form-item>
            <div>
              <special-requests-grid v-model="job.satisfiedRequests" no="satisfiedRequests" :customer-id="job.customerId" :lob="job.lob" :job="job" :is-edit="!viewStatus" />
            </div>
            <el-form-item v-if="!isFba" :label="$t('SeaExport.HsCode')" style="margin-top: 10px">
              <el-input v-model="job.hsCode" :class="importDifferenceField.hsCode ? 'red-border' : ''" no="84" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input
                v-model="job.remarks"
                no="85"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,val=>{job.remarks=val})"
              />
            </el-form-item>
          </div>
          <!-- FBA相关信息-->
          <div v-if="isFba" class="section form-column">
            <el-form
              :disabled="viewStatus"
              label-width="120px"
              label-position="right"
            >
              <el-form-item v-if="!isEdit" :label="$t('AirExport.ServiceChannel')">
                <cargo-advance-select
                  no="serviceChannel"
                  disabled
                  :select-type="selectTypeNames.basic_data_FbaChannel"
                  filterable
                  :method-params="{shippingType: fbaJob.shippingType, active: true}"
                  :clearable="true"
                  :default-value="fbaJob.serviceChannel"
                  @parentCallBack="p=>{fbaJob.serviceChannel=p.value;}"
                />
              </el-form-item>
              <el-form-item v-if="isEdit" :label="$t('AirExport.ServiceChannel')">
                <el-select v-model="fbaJob.serviceChannel" filterable clearable no="138" @change="changeServiceChannel">
                  <el-option
                    v-for="(item,index) in channel4JobSelect"
                    :key="index"
                    :label="item.channelName"
                    :value="item.channelName"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('AirExport.EstimatedStorageGoodArrivalTime') }}</span>
                <el-date-picker
                  v-model="fbaJob.preWarehousingTime"
                  no="preWarehousingTime"
                  type="datetime"
                  style="width:100%;"
                  clearable
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  @change="preWarehousingChangeHandler"
                />
              </el-form-item>
              <el-form-item :label="$t('AirExport.ExpectedTimeIntoAmazonWarehouse')">
                <el-date-picker
                  v-model="fbaJob.preAmazonWhTime"
                  no="preAmazonWhTime"
                  :disabled="viewStatus"
                  type="date"
                  style="width:100%;"
                  clearable
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_Destination') }}</span>
                <div style="display: flex; flex: 1;">
                  <el-tooltip :content="fbaJob.warehouseCode" placement="bottom-end">
                    <el-cascader
                      v-model="fbaJob.warehouseCode"
                      style="padding-right: 2px;"
                      :options="destinations"
                      filterable
                      :clearable="true"
                      no="139"
                      @focus="JobUtils.focusWarehouseCode(fbaJob)"
                      @blur="JobUtils.blurWarehouseCode(fbaJob)"
                      @change="p=>{JobUtils.warehouseCodeHandler(fbaJob, p);changeWarehouseCode}"
                    />
                  </el-tooltip>
                  <el-checkbox v-model="fbaJob.remoteWarehouse" no="remoteWarehouse">{{ $t('AirExport.RemoteWarehouse') }}</el-checkbox>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Warehouse.DestinationCountry')">
                <el-input v-model="fbaJob.country" :disabled="true" no="country" />
              </el-form-item>
              <el-form-item :label="$t('AirExport.ZipCode')">
                <el-input v-model="fbaJob.zipCode" :disabled="true" no="zipCode" />
              </el-form-item>
              <el-form-item :label="$t('AirExport.DestinationDeliveryMethod')">
                <el-select v-model="fbaJob.destinationDistribution" no="destinationDistribution" filterable @change="destinationDistributionChange">
                  <el-option
                    v-for="(item,index) in FbaJobConstants.ORDER_DESTINATION_DISTRIBUTION_TYPES"
                    :key="index"
                    :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('AirExport.CourierCompany')">
                <el-select v-model="fbaJob.expressCompany" no="expressCompany" placeholder="" clearable>
                  <el-option
                    v-for="item in FbaJobConstants.EXPRESS_COMPANYS"
                    :key="item.code"
                    :label="item.chineseName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('AirExport.CourierNumber')">
                <el-input v-model="fbaJob.expressNo" no="expressNo" />
              </el-form-item>
              <el-form-item :label="$t('AirExport.POOriginalOrderNumber')">
                <el-input v-model="fbaJob.poNumber" no="poNumber" />
              </el-form-item>
              <el-form-item :label="'Shipment Id'">
                <el-input v-model="fbaJob.shipmentId" no="shipmentId" />
              </el-form-item>
              <el-form-item :label="'Reference Id'">
                <el-input v-model="fbaJob.referenceId" no="referenceId" />
              </el-form-item>
              <el-form-item :label="$t('AirExport.EORIBusinessNumber')">
                <el-input v-model="fbaJob.eoriNo" no="eoriNo" />
              </el-form-item>
              <el-form-item :label="$t('AirExport.VATTaxNumber')">
                <el-input v-model="fbaJob.vatNo" no="vatNo" />
              </el-form-item>
              <el-form-item :label="$t('AirExport.VATRegistrationCountry')">
                <cargo-advance-select
                  no="taxRegisterCountry"
                  :select-type="selectTypeNames.basic_data_Country"
                  filterable
                  :callback-params="{key:'taxRegisterCountry'}"
                  callback-method-type="value"
                  :default-value="fbaJob.taxRegisterCountry"
                  @parentCallBack="p=>{fbaJob.taxRegisterCountry = p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('AirExport.VATRegistrationAddress')">
                <el-input v-model="fbaJob.taxRegisterAddress" no="taxRegisterAddress" />
              </el-form-item>
              <el-form-item :label="$t('AirExport.VATCompanyEnglishName')">
                <el-input v-model="fbaJob.taxCompany" no="taxCompany" />
              </el-form-item>

              <hr style="margin-top: 20px;margin-bottom: 20px;">
              <span class="title">{{ $t('SeaExport.PODDeliveryInformation') }}</span>
              <el-form-item :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToWarehouseTime')">
                <el-date-picker
                  v-model="job.estWarehouseDeliveryTime"
                  no="estWarehouseDeliveryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToWarehouseTime')">
                <el-date-picker
                  v-model="job.actWarehouseDeliveryTime"
                  no="actWarehouseDeliveryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item :title="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime')">
                <el-date-picker
                  v-model="job.estGoodsDeliveryTime"
                  no="estGoodsDeliveryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item :title="$t('SeaExport.ActualDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToCustomersWarehouseTime')">
                <el-date-picker
                  v-model="job.actGoodsDeliveryTime"
                  no="actGoodsDeliveryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item :label="$t('AirExport.EstimatedDeliveryTime')">
                <el-date-picker
                  v-model="job.estDeliveryTime"
                  no="estDeliveryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item :label="$t('AirExport.ActualDeliveryTime')">
                <el-date-picker
                  v-model="job.actDeliveryTime"
                  no="actDeliveryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input
                v-model="job.userDefinedField1"
                no="86"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),job.userDefinedField1,val=>{job.userDefinedField1=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input
                v-model="job.userDefinedField2"
                no="87"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),job.userDefinedField2,val=>{job.userDefinedField2=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input
                v-model="job.userDefinedField3"
                no="88"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),job.userDefinedField3,val=>{job.userDefinedField3=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField4')">
              <el-input
                v-model="job.userDefinedField4"
                no="89"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField4'),job.userDefinedField4,val=>{job.userDefinedField4=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="job.taxNature"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </div>
        </div>
        <div style="flex-direction: column">
          <div class="section">
            <div class="goods-info">
              <el-form-item class="auto-width">
                <div style="display: flex;text-align: left" class="title-row">
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.Quantity') }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.Weight') }}{{ openImperial ? 'LB' : 'KGS' }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.Cubage') }}{{ openImperial ? 'CFT' : 'CBM' }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.ChargedWeight') }}{{ openImperial ? 'LB' : 'KGS' }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('queryJob.Density') }}kg/m³</div>
                  <div v-if="isFba" style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.VolumetricWeight') }}KGS</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.Size') }}CM</div>
                  <div v-if="showImperialButton && viewStatus" style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">
                    {{ $t('CargoMsg.Cargo_ImperialUnits') }}
                    <div :class="isOpenImperial?'el-switch is-checked':'el-switch'">
                      <span class="el-switch__core" style="width: 40px;" @click="isOpenImperial = !isOpenImperial" />
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Consignation')" class="goods-info-item">
                <auto-number-input
                  v-model="job.quantityContract"
                  no="90"
                  :precision="0"
                  :min="0"
                  :class="importDifferenceField.quantityContract ? 'red-border' : ''"
                  @change="calcEstVolumetricAndChargeWeight(false)"
                />
                <div v-show="openImperial">
                  <auto-number-input
                    v-model="job.weightContractImperial"
                    no="weightContractImperial"
                    :precision="2"
                    :min="0"
                    :class="importDifferenceField.weightContract ? 'red-border' : ''"
                    @change="weightContractImperialChange();"
                  />
                  <auto-number-input
                    v-model="job.cubAgeContractImperial"
                    no="cubAgeContractImperial"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.cubageContract ? 'red-border' : ''"
                    @change="cubAgeContractImperialChange();"
                  />
                  <auto-number-input
                    v-model="job.chargeWeightImperial"
                    no="chargeWeightImperial"
                    :precision="3"
                    :min="0"
                    :disabled="true"
                    :class="importDifferenceField.chargeWeight ? 'red-border' : ''"
                  />
                </div>
                <div v-show="!openImperial">
                  <auto-number-input
                    v-model="job.weightContract"
                    no="91"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.weightContract ? 'red-border' : ''"
                    @change="weightContractChange(true);calcEstVolumetricAndChargeWeight(false)"
                  />
                  <auto-number-input
                    v-model="job.cubageContract"
                    no="92"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.cubageContract ? 'red-border' : ''"
                    @change="cubageContractChange(true);calcEstVolumetricAndChargeWeight(false)"
                  />
                  <auto-number-input
                    v-model="job.chargeWeight"
                    no="93"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.chargeWeight ? 'red-border' : ''"
                    @change="pm.chargeWeightImperialChange('chargeWeight', 'chargeWeightImperial')"
                  />
                </div>
                <auto-number-input
                  v-model="job.densityContract"
                  :precision="3"
                  :min="0"
                  no="140"
                  :class="importDifferenceField.densityContract ? 'red-border' : ''"
                />
                <auto-number-input
                  v-if="isFba"
                  v-model="job.volumetricWeightContract"
                  no="80"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  @change="calcEstVolumetricAndChargeWeight(false, job.volumetricWeightContract)"
                />
                <el-input v-model="job.commissionDimensions" no="commissionDimensions" style="width: 200px;padding-right: 5px" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Booking')" class="goods-info-item">
                <auto-number-input
                  v-model="job.quantityBooking"
                  no="94"
                  :precision="0"
                  :min="0"
                  :class="importDifferenceField.quantityBooking ? 'red-border' : ''"
                  @change="pm.weightCubageChangeHandler('quantityBooking');calcEstVolumetricAndChargeWeight(true)"
                />
                <div v-show="openImperial">
                  <auto-number-input
                    v-model="job.weightBookingImperial"
                    no="weightBookingImperial"
                    :precision="2"
                    :min="0"
                    :class="importDifferenceField.weightBooking ? 'red-border' : ''"
                    @change="pm.weightCubAgeImperialChangeHandler('weightBooking');"
                  />
                  <auto-number-input
                    v-model="job.cubAgeBookingImperial"
                    no="cubAgeBookingImperial"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.cubageBooking ? 'red-border' : ''"
                    @change="pm.weightCubAgeImperialChangeHandler('cubageBooking');"
                  />
                  <auto-number-input
                    v-model="job.chargeWeightBookingImperial"
                    no="chargeWeightBookingImperial"
                    :precision="3"
                    :min="0"
                    :disabled="true"
                    :class="importDifferenceField.chargeWeightBooking ? 'red-border' : ''"
                  />
                </div>
                <div v-show="!openImperial">
                  <auto-number-input
                    v-model="job.weightBooking"
                    no="95"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.weightBooking ? 'red-border' : ''"
                    @change="pm.doWeightCubAgeChangeHandler('weightBooking');calcEstVolumetricAndChargeWeight(true)"
                  />
                  <auto-number-input
                    v-model="job.cubageBooking"
                    no="96"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.cubageBooking ? 'red-border' : ''"
                    @change="pm.doWeightCubAgeChangeHandler('cubageBooking');calcEstVolumetricAndChargeWeight(true)"
                  />
                  <auto-number-input
                    v-model="job.chargeWeightBooking"
                    no="97"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.chargeWeightBooking ? 'red-border' : ''"
                    @change="pm.chargeWeightImperialChange('chargeWeightBooking', 'chargeWeightBookingImperial')"
                  />
                </div>
                <auto-number-input
                  v-model="job.densityBooking"
                  :precision="3"
                  :min="0"
                  no="141"
                  :class="importDifferenceField.densityBooking ? 'red-border' : ''"
                />
                <auto-number-input
                  v-if="isFba"
                  v-model="job.volumetricWeightBooking"
                  no="81"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  @change="calcEstVolumetricAndChargeWeight(true, job.volumetricWeightBooking)"
                />
                <el-input v-model="job.measurements" no="measurements" style="width: 200px;padding-right: 5px" @input="pm.weightCubageChangeHandler('measurements')" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.FrontCabinActual')" class="goods-info-item">
                <auto-number-input
                  v-model="job.quantityActual"
                  no="98"
                  :precision="0"
                  :min="0"
                  :class="importDifferenceField.quantityActual ? 'red-border' : ''"
                  @change="pm.weightCubageChangeHandler('quantityActual');quantityActualChange()"
                />
                <div v-show="openImperial">
                  <auto-number-input
                    v-model="job.weightActualImperial"
                    no="weightActualImperial"
                    :precision="2"
                    :min="0"
                    :class="importDifferenceField.weightActual ? 'red-border' : ''"
                    @change="weightActualImperialChange"
                  />
                  <auto-number-input
                    v-model="job.cubAgeActualImperial"
                    no="cubAgeActualImperial"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.cubageActual ? 'red-border' : ''"
                    @change="cubAgeActualImperialChange"
                  />
                  <auto-number-input
                    v-model="job.cWeightImperial"
                    no="cWeightImperial"
                    :precision="3"
                    :min="0"
                    :disabled="true"
                    :class="importDifferenceField.cWeight ? 'red-border' : ''"
                  />
                </div>
                <div v-show="!openImperial">
                  <auto-number-input
                    v-model="job.weightActual"
                    no="99"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.weightActual ? 'red-border' : ''"
                    @change="weightActualChange(true)"
                  />
                  <auto-number-input
                    v-model="job.cubageActual"
                    no="100"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.cubageActual ? 'red-border' : ''"
                    @change="cubageActualChange(true)"
                  />
                  <auto-number-input
                    v-model="job.cWeight"
                    no="101"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.cWeight ? 'red-border' : ''"
                    @change="isFba ? changeChargeWeight : pm.weightCubageChangeHandler('chargeWeightActual')"
                  />
                </div>
                <auto-number-input
                  v-model="job.densityActual"
                  :precision="3"
                  :min="0"
                  no="142"
                  :class="importDifferenceField.densityActual ? 'red-border' : ''"
                />
                <auto-number-input
                  v-if="isFba"
                  v-model="job.volumetricWeight"
                  no="82"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  @change="changeVolumetricWeight"
                />
                <el-input v-model="job.dimensionsActual" no="dimensionsActual" style="width: 200px;padding-right: 5px" @input="pm.weightCubageChangeHandler('dimensionsActual')" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.FreightStation')" class="goods-info-item">
                <auto-number-input
                  v-model="job.quantityStation"
                  no="150"
                  :precision="0"
                  :min="0"
                  :class="importDifferenceField.quantityStation ? 'red-border' : ''"
                  @change="pm.weightCubageChangeHandler('quantityStation');calcStationVolumetricAndChargeWeight()"
                />
                <div v-show="openImperial">
                  <auto-number-input
                    v-model="job.weightStationImperial"
                    no="weightStationImperial"
                    :precision="2"
                    :min="0"
                    :class="importDifferenceField.weightStation ? 'red-border' : ''"
                    @change="weightStationImperialChange();"
                  />
                  <auto-number-input
                    v-model="job.cubAgeStationImperial"
                    no="cubAgeStationImperial"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.cubageStation ? 'red-border' : ''"
                    @change="cubAgeStationImperialChange();"
                  />
                  <auto-number-input
                    v-model="job.chargeWeightStationImperial"
                    no="chargeWeightStationImperial"
                    :precision="3"
                    :min="0"
                    :disabled="true"
                  />
                </div>
                <div v-show="!openImperial">
                  <auto-number-input
                    v-model="job.weightStation"
                    no="151"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.weightStation ? 'red-border' : ''"
                    @change="weightStationChange(true);calcStationVolumetricAndChargeWeight()"
                  />
                  <auto-number-input
                    v-model="job.cubageStation"
                    no="152"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.cubageStation ? 'red-border' : ''"
                    @change="cubageStationChange(true);calcStationVolumetricAndChargeWeight()"
                  />
                  <auto-number-input
                    v-model="job.chargeWeightStation"
                    no="153"
                    :precision="3"
                    :min="0"
                    @change="pm.chargeWeightImperialChange('chargeWeightStation', 'chargeWeightStationImperial')"
                  />
                </div>
                <auto-number-input
                  v-model="job.densityStation"
                  :precision="3"
                  :min="0"
                  no="154"
                />
                <auto-number-input
                  v-if="isFba"
                  v-model="job.volumetricWeightStation"
                  no="155"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  @change="calcStationVolumetricAndChargeWeight(job.volumetricWeightStation)"
                />
                <el-input v-model="job.freightStationDimensions" no="freightStationDimensions" style="width: 200px;padding-right: 5px" @input="pm.weightCubageChangeHandler('freightStationDimensions')" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.SignBill')" class="goods-info-item">
                <auto-number-input
                  v-model="job.quantitySigning"
                  no="156"
                  :precision="0"
                  :min="0"
                  :class="importDifferenceField.quantitySigning ? 'red-border' : ''"
                  @change="pm.weightCubageChangeHandler('quantitySigning');calcSigningVolumetricAndChargeWeight()"
                />
                <div v-show="openImperial">
                  <auto-number-input
                    v-model="job.weightSigningImperial"
                    no="weightSigningImperial"
                    :precision="2"
                    :min="0"
                    :class="importDifferenceField.weightSigning ? 'red-border' : ''"
                    @change="weightSigningImperialChange();"
                  />
                  <auto-number-input
                    v-model="job.cubAgeSigningImperial"
                    no="cubAgeSigningImperial"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.cubageSigning ? 'red-border' : ''"
                    @change="cubAgeSigningImperialChange();"
                  />
                  <auto-number-input
                    v-model="job.chargeWeightSigningImperial"
                    no="chargeWeightSigningImperial"
                    :precision="3"
                    :min="0"
                    :disabled="true"
                    :class="importDifferenceField.chargeWeightSigning ? 'red-border' : ''"
                  />
                </div>
                <div v-show="!openImperial">
                  <auto-number-input
                    v-model="job.weightSigning"
                    no="157"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.weightSigning ? 'red-border' : ''"
                    @change="weightSigningChange(true);calcSigningVolumetricAndChargeWeight()"
                  />
                  <auto-number-input
                    v-model="job.cubageSigning"
                    no="158"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.cubageSigning ? 'red-border' : ''"
                    @change="cubageSigningChange(true);calcSigningVolumetricAndChargeWeight()"
                  />
                  <auto-number-input
                    v-model="job.chargeWeightSigning"
                    no="159"
                    :precision="3"
                    :min="0"
                    :class="importDifferenceField.chargeWeightSigning ? 'red-border' : ''"
                    @change="pm.chargeWeightImperialChange('chargeWeightSigning', 'chargeWeightSigningImperial')"
                  />
                </div>
                <auto-number-input
                  v-model="job.densitySigning"
                  :precision="3"
                  :min="0"
                  no="160"
                  :class="importDifferenceField.densitySigning ? 'red-border' : ''"
                />
                <auto-number-input
                  v-if="isFba"
                  v-model="job.volumetricWeightSigning"
                  no="161"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  @change="calcSigningVolumetricAndChargeWeight(job.volumetricWeightSigning)"
                />
                <el-input v-model="job.dimensionsSigning" no="dimensionsSigning" style="width: 200px;padding-right: 5px" @input="pm.weightCubageChangeHandler('dimensionsSigning')" />
              </el-form-item>
              <el-form-item v-if="job.operateType!==0" :label="$t('SeaExport.Documentation')" class="goods-info-item">
                <auto-number-input
                  v-model="mawbDoc.quantity"
                  no="102"
                  :precision="0"
                  :min="0"
                  @change="pm.weightCubageChangeHandler('quantityMBL');calcActVolumetricAndChargeWeight(true)"
                />
                <div v-show="openImperial">
                  <auto-number-input
                    v-model="mawbDoc.weightImperial"
                    no="weightImperial"
                    :precision="2"
                    :min="0"
                    @change="pm.weightCubAgeImperialChangeHandler('weightMBL');"
                  />
                  <auto-number-input
                    v-model="mawbDoc.cubAgeImperial"
                    no="cubAgeImperial"
                    :precision="3"
                    :min="0"
                    @change="pm.weightCubAgeImperialChangeHandler('cubageMBL');"
                  />
                  <auto-number-input
                    v-model="mawbDoc.chargeWeightImperial"
                    no="chargeWeightImperial"
                    :precision="3"
                    :min="0"
                    :disabled="true"
                  />
                </div>
                <div v-show="!openImperial">
                  <auto-number-input
                    v-model="mawbDoc.weight"
                    no="103"
                    :precision="3"
                    :min="0"
                    @change="pm.doWeightCubAgeChangeHandler('weightMBL');calcActVolumetricAndChargeWeight(true)"
                  />
                  <auto-number-input
                    v-model="mawbDoc.cubage"
                    no="104"
                    :precision="3"
                    :min="0"
                    @change="pm.doWeightCubAgeChangeHandler('cubageMBL');calcActVolumetricAndChargeWeight(true)"
                  />
                  <auto-number-input
                    v-model="mawbDoc.cWeight"
                    no="105"
                    :precision="3"
                    :min="0"
                    @change="pm.doWeightCubAgeChangeHandler('chargeWeightMBL')"
                  />
                </div>
                <auto-number-input
                  v-model="job.densityDoc"
                  :precision="3"
                  :min="0"
                  no="143"
                  :class="importDifferenceField.densityDoc ? 'red-border' : ''"
                />
                <auto-number-input
                  v-if="isFba"
                  v-model="mawbDoc.volumetricWeight"
                  no="82"
                  :precision="3"
                  :min="0"
                  :disabled="true"
                  @change="calcActVolumetricAndChargeWeight(true, mawbDoc.volumetricWeight)"
                />
                <el-input v-model="job.docDimensions" no="docDimensions" style="width: 200px;padding-right: 5px" />
              </el-form-item>
              <div v-if="!isFba" style="display:flex; text-align: left">
                <el-form-item
                  :label="$t('SeaExport.Package')"
                  :label-width="'100px'"
                >
                  <!-- <cargo-advance-select
                    filterable
                    :select-type="selectTypeNames.basic_data_Packing"
                    callback-method-type="value"
                    :default-value="job.packing"
                    tag-name="chineseName"
                    :callback-params="{key:'packing'}"
                    style="width: 170px;padding-left: 10px"
                    @parentCallBack="setJobSelectValue"
                  /> -->
                  <cargo-packing-select
                    no="106"
                    style="margin-left: 12px;width: 190px"
                    :default-value="job.packing"
                    :callback-params="{}"
                    placeholder=" "
                    :class="importDifferenceField.packing ? 'red-border' : ''"
                    @change="p => {p.key = 'packing';setJobSelectValue(p)}"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.CustomersCollectByBubble')" label-width="95px">
                  <el-select
                    v-if="splitBubbleCollectionFormat"
                    :value="job.pbProportion||''"
                    no="107"
                    clearable
                    :filterable="!pbProportionCheck"
                    :allow-create="!pbProportionCheck"
                    :class="importDifferenceField.pbProportion ? 'red-border' : ''"
                    @focus="onPbProportionFocus"
                    @input="val=>{job.pbProportion=val}"
                    @change="pm.weightCubageChangeHandler('pbProportion')"
                  >
                    <el-option v-for="(item, index) in SPLIT_BUBBLE_COLLECT_ITEMS" :key="index" :label="$getLangColumn(item)" :value="item.code" />
                  </el-select>
                  <template v-else>
                    <el-input-number v-model="job.pbProportion" no="107" style="width: 95px;" controls-position="right" :min="0" :max="999999999" @input="val=>{job.pbProportion}" @change="pm.weightCubageChangeHandler('pbProportion')" /><span>%</span>
                  </template>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.CollectionBySupplier')" label-width="100px" style="margin-left: 10px;">
                  <el-select
                    v-if="splitBubbleCollectionFormat"
                    :value="job.pbProportion2||''"
                    no="108"
                    clearable
                    :filterable="!pbProportion2Check"
                    :allow-create="!pbProportion2Check"
                    :class="importDifferenceField.pbProportion2 ? 'red-border' : ''"
                    @focus="onPbProportion2Focus"
                    @input="val=>{job.pbProportion2=val}"
                    @change="pm.weightCubageChangeHandler('pbProportion2')"
                  >
                    <el-option v-for="(item, index) in SPLIT_BUBBLE_COLLECT_ITEMS" :key="index" :label="$getLangColumn(item)" :value="item.code" />
                  </el-select>
                  <template v-else>
                    <el-input-number v-model="job.pbProportion2" no="108" style="width: 85px;" controls-position="right" :min="0" :max="999999999" @input="val=>{job.pbProportion2}" @change="pm.weightCubageChangeHandler('pbProportion2')" /><span>%</span>
                  </template>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Slac')" label-width="100px" style="margin-left: 10px;">
                  <el-input-number v-model="job.slac" no="slac" :class="importDifferenceField.slac ? 'red-border' : ''" style="width: 85px;" :min="0" :precision="0" :controls="false" @change="p=>{pm.slacChangeHandler(p)}" />
                </el-form-item>
                <el-form-item />
              </div>
            </div>
            <div v-if="isFba" style="display:flex; text-align: left; margin-left: 20px;">
              <el-row>
                <el-col :span="4.8">
                  <el-form-item label-width="80px">
                    <span slot="label" class="blue">{{ $t('FbaJob.ChargingMethod') }}</span>
                    <el-radio-group v-model="fbaJob.chargingMethod" no="chargingMethod" @change="chargingMethodChange">
                      <el-radio :label="'0'">{{ 'KG' }}</el-radio>
                      <el-radio :label="'1'">{{ 'CBM' }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <el-form-item :label="$t('SeaExport.pbProportion')" label-width="80px">
                    <span style="display:flex;">
                      <!--                      <el-input-number v-model="fbaJob.bubbleSplittingRatio" style="width: 90px;" no="bubbleSplittingRatio" controls-position="right" :max="100" :min="0" :precision="0" @input="val=>{fbaJob.bubbleSplittingRatio}" @change="p=>{fbaJob.bubbleSplittingRatio=p.value;job.pbProportion=p.value;pm.weightCubageChangeHandler('pbProportion');}" />%-->
                      <el-input v-model="fbaJob.bubbleSplittingRatio" no="bubbleSplittingRatio" @change="bubbleSplittingRatioChange" />%
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <el-form-item :label="$t('SeaExport.pbProportion2')" label-width="80px">
                    <span style="display:flex;">
                      <el-input-number v-model="job.pbProportion2" no="108" style="width: 90px;" controls-position="right" :min="0" :max="999999999" @input="val=>{job.pbProportion2}" @change="pm.weightCubageChangeHandler('pbProportion2')" /><span>%</span>
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <el-form-item v-if="isFba" :label="$t('FbaChannel.bubbleCountingRatio')" label-width="80px">
                    <!--                    <el-input-number v-model="fbaJob.bubbleCountingRatio" style="width: 90px;" no="bubbleCountingRatio" controls-position="right" :max="9999" :min="0" @change="bubbleCountingChange"/>-->
                    <el-input v-model="fbaJob.bubbleCountingRatio" no="bubbleCountingRatio" style="width: 100%;" @change="bubbleCountingChange" />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="section form-row">
            <div style="display:flex;justify-content: space-between;width: 1200px;max-width: 100%">
              <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')" class="auto-width" style="width: 290px">
                <cargo-rich-textarea
                  v-model="job.cargoEnglishName"
                  no="110"
                  :text-chars="0"
                  :warning-count="45"
                  :disabled="viewStatus"
                  :english-letter-auto-uppercase="isUppercaseByConfig"
                  style="height: 110px"
                  :class="job.cargoEnglishNameWarning === 1 ? 'red-border' : ''"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),job.cargoEnglishName,val=>{pm.cargoEnglishNameChangeHandler(val)}, isUppercaseByConfig,{warningCount:45,maxChar: 0})"
                  @blur="pm.cargoEnglishNameBlurHandler()"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Marks')" class="auto-width" style="width: 290px">
                <cargo-rich-textarea
                  v-model="job.mark"
                  no="111"
                  :text-chars="0"
                  :warning-count="45"
                  :disabled="viewStatus"
                  :auto-uppercase="isUppercaseByConfig"
                  style="height: 110px"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,val=>{pm.markChangeHandler(val)}, isUppercaseByConfig,{warningCount:45,maxChar: 0})"
                  @blur="pm.markBlurHandler()"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.ChineseDescriptionOfGoods')" class="auto-width" style="width: 290px">
                <cargo-rich-textarea
                  v-model="job.cargoChineseName"
                  no="112"
                  :text-chars="0"
                  :warning-count="-1"
                  :disabled="viewStatus"
                  :auto-uppercase="true"
                  style="height: 110px"
                  :class="job.cargoChineseNameWarning === 1 ? 'red-border' : ''"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val})"
                />
              </el-form-item>
              <!-- 特殊操作码 -->
              <el-form-item :label="$t('SeaExport.specialOperationCode')" class="auto-width" style="width: 290px">
                <el-tooltip :content="job.specialOperationCode" placement="left">
                  <div slot="content" v-html="job.specialOperationCode || $t('SeaExport.NoData')" />
                  <el-input
                    no="1211"
                    :value="job.specialOperationCode"
                    :placeholder="viewStatus ? '' : $t('SeaExport.doubleClickToAddSpecialOperationCode')"
                    :rows="6"
                    type="textarea"
                    style="height: 110px;"
                    @dblclick.native="selectSpecialOperationCodeDialog.value=job.specialOperationCode;selectSpecialOperationCodeDialog.visible=!viewStatus"
                  />
                </el-tooltip>
              </el-form-item>
            </div>
          </div>
        </div>
        <div
          class="section"
          style="width:100%"
        >
          <span class="title">{{ $t('SeaExport.CustomerDeliveryInfo') }}</span>
          <div>
            <el-button v-if="!isFba" no="CodeSearching" :disabled="viewStatus" type="primary" @click="codeSearch">{{ $t('SeaExport.CodeSearching') }}</el-button>
            <el-button v-if="isFba" no="FbaCodeSearching" :disabled="viewStatus" type="primary" @click="fbaCodeSearchBtn">{{ $t('SeaExport.CodeSearching') }}</el-button>
          </div>
          <div class="form-row" style="display:flex;flex-direction:row;margin-top:8px">
            <el-form
              label-width="50px"
              label-position="left"
              style="margin-right:10px"
            >
              <el-form-item :label="$t('SeaExport.Shipper')" class="custom">
                <cargo-input v-model="job.shipperCode" :disabled="viewStatus" no="shipperCode" :class="importDifferenceField.shipperCode ? 'red-border' : ''" style="width:110px;margin-right: 5px" :auto-uppercase="notUppercaseShipperConsigneNotify" @change="data => {pm.shipperCodeChange(data)}" />
                <cargo-company-select
                  no="113"
                  :disabled="viewStatus"
                  :method-params="{shipper:true,active:true}"
                  :default-value="job.shipperId||''"
                  style="display: inline-block;width:135px;"
                  :fields="['englishName']"
                  tag-name="englishName"
                  placeholder=" "
                  :class="importDifferenceField.shipperId ? 'red-border' : ''"
                  @change="data => {pm.shipperChange(data)}"
                />
              </el-form-item>
              <el-form-item v-for="i in 7" :key="i" label-width="0">
                <cargo-input
                  :ref="'shipperLine'+i"
                  v-model="job['shipperLine'+i]"
                  :disabled="viewStatus"
                  :no="'shipperLine'+i"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField['shipperLine'+i] ? 'red-border' : ''"
                  @change="()=>wrapAddr(job,'shipperLine'+i,i+1 > 7 ? null :'shipperLine'+(i+1),200)"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,notUppercaseShipperConsigneNotify)"
                />
              </el-form-item>
            </el-form>
            <el-form
              label-width="50px"
              label-position="left"
              style="margin-right:20px"
            >
              <el-form-item :label="$t('SeaExport.Consignee')" class="custom">
                <cargo-input v-model="job.consigneeCode" :disabled="viewStatus" no="consigneeCode" :class="importDifferenceField.consigneeCode ? 'red-border' : ''" style="width:110px;margin-right: 5px" :auto-uppercase="notUppercaseShipperConsigneNotify" @change="data => {pm.consigneeCodeChange(data)}" />
                <cargo-company-select
                  no="115"
                  :disabled="viewStatus"
                  :method-params="{consignee:true,active:true}"
                  :default-value="job.consigneeId||''"
                  style="display: inline-block;width:135px;"
                  :fields="['englishName']"
                  tag-name="englishName"
                  placeholder=" "
                  :class="importDifferenceField.consigneeId ? 'red-border' : ''"
                  @change="data => {pm.consigneeChange(data)}"
                />
              </el-form-item>
              <el-form-item v-for="i in 7" :key="i" label-width="0">
                <cargo-input
                  :ref="'consigneeLine'+i"
                  v-model="job['consigneeLine'+i]"
                  :disabled="viewStatus"
                  :no="'consigneeLine'+i"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField['consigneeLine'+i] ? 'red-border' : ''"
                  @change="()=>wrapAddr(job,'consigneeLine'+i,i+1 > 7 ? null :'consigneeLine'+(i+1),200)"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,notUppercaseShipperConsigneNotify)"
                />
              </el-form-item>
            </el-form>
            <el-form
              label-width="50px"
              label-position="left"
              style="margin-right:20px"
            >
              <el-form-item :label="$t('SeaExport.NotifyParty')" class="custom">
                <cargo-input v-model="job.notifyCode" :disabled="viewStatus" no="notifyCode" :class="importDifferenceField.notifyCode ? 'red-border' : ''" style="width:110px;margin-right: 5px" :auto-uppercase="notUppercaseShipperConsigneNotify" @change="data => {pm.notifyCodeChange(data)}" />
                <cargo-company-select
                  no="117"
                  :disabled="viewStatus"
                  :method-params="{notify:true,active:true}"
                  :default-value="job.notifyId||''"
                  style="display: inline-block;width:135px;"
                  :fields="['englishName']"
                  tag-name="englishName"
                  placeholder=" "
                  :class="importDifferenceField.notifyId ? 'red-border' : ''"
                  @change="data => {pm.notifyChange(data)}"
                />
              </el-form-item>
              <el-form-item v-for="i in 7" :key="i" label-width="0">
                <cargo-input
                  :ref="'notifyLine'+i"
                  v-model="job['notifyLine'+i]"
                  :disabled="viewStatus"
                  :no="'notifyLine'+i"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField['notifyLine'+i] ? 'red-border' : ''"
                  @change="()=>wrapAddr(job,'notifyLine'+i,i+1 > 7 ? null :'notifyLine'+(i+1),200)"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,notUppercaseShipperConsigneNotify)"
                />
              </el-form-item>
            </el-form>
            <div>
              <span style="display:inline-block;line-height:28px;padding-bottom: 5px;">{{
                $t('SeaExport.SecondNotifyParty')
              }}</span>
              <cargo-rich-textarea
                v-model="job.alsoNotify"
                no="119"
                :disabled="viewStatus"
                :text-chars="0"
                style="width: 310px;height: 200px;"
                :class="importDifferenceField.alsoNotify ? 'red-border' : ''"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.SecondNotifyParty'),job.alsoNotify,val=>{job.alsoNotify=val},true,{warningCount:45,maxChar: 0})"
              />
            </div>
          </div>
        </div>
      </div>
    </el-form>

    <cargo-contacts-info-dialog
      v-if="showContactsInfoDialog"
      :visible.sync="showContactsInfoDialog"
      :customer-id="job.customerId"
      :customer-contact="job.customerContact"
    />
    <!--输入中转信息-->
    <transit-port-dialog :visible.sync="transitPortDialog.visible" :job="transitPortDialog.job" @enter="transitPortDialogCallback" />
    <!--选择主单-->
    <select-mawb-dialog
      :visible.sync="selectMawbDialog.visible"
      :type="selectMawbDialog.type"
      :operate-type="selectMawbDialog.operateType"
      :carrier-id="selectMawbDialog.carrierId"
      @enterEvent="selectedMAWBHandler"
    />
    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      v-if="selectOperationReqDialog.visible"
      :visible.sync="selectOperationReqDialog.visible"
      lob="AE"
      :value="selectOperationReqDialog.value"
      @callback="val=>{job.operationContent=val;this.pm.syncDocHandlingInfo()}"
    />
    <!-- 特殊操作代码弹窗 -->
    <select-special-operation-code-dialog
      v-if="selectSpecialOperationCodeDialog.visible"
      :visible.sync="selectSpecialOperationCodeDialog.visible"
      lob="AE"
      :value="selectSpecialOperationCodeDialog.value"
      @callback="val=>{job.specialOperationCode = val;}"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAdvanceText"
    ><cargo-rich-textarea
       v-model="advanceTextDialog.value"
       :disabled="showDialog"
       :text-chars="advanceTextDialog.formatObj.maxChar"
       :auto-uppercase="advanceTextDialog.isUppercase"
       :warning-count="advanceTextDialog.formatObj.warningCount"
       style="height: 320px;"
       no="144"
     />
      <span slot="footer">
        <el-button v-show="!viewStatus" no="120" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="121"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- SOP接收人弹窗 -->
    <sop-dialog
      :visible.sync="sopDialog.visible"
      :cmp-idx="sopDialog.cmpIdx"
      :job="job"
      :agent="sopDialog.agent"
      lob="AE"
      :contact-list="sopDialog.contactList"
      @updateJob="$emit('updateJob')"
    />
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="billAddressDialog.job"
      :params="billAddressDialog.params"
      @callback="codeSearchCallback"
    />
    <!--进仓编号双击弹框-->
    <ware-house-dialog
      :visible.sync="warehouseDialog.visible"
      :job="warehouseDialog.job"
      @warehouseCommitCallback="warehouseCommitCallback"
    />
    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
    <!-- Fba收发通地址弹窗 -->
    <fba-bill-address-dialog
      :visible.sync="fbaBillAddressDialog.visible"
      :job="fbaJob"
      @callback="fbaCodeSearchCallback"
    />

    <!-- 选择尺寸 -->
    <common-dimensions-dialog
      v-if="dimensionsDialog.visible"
      :visible.sync="dimensionsDialog.visible"
      :open-imperial="openImperial"
      @sizeData="sizeDataHandler"
      @close="dimensionsDialog.visible = false"
    />
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'

import cargoContactsInfoDialog from '@/components/Cargo/Job/cargoContactsInfoDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import SpecialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import selectData from '@/utils/selectData'
import { cacheName, cache } from '@/utils/cacheManager'
import { TabGeneralHP } from './tabGeneralHP'
import NumberInput from '@/components/Cargo/Common/numberInput'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import sopPic from '@/assets/sop.png'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { Company } from '@/class/model/mdm/Company'
import { Contract } from '@/class/model/mdm/Contract'
import { User } from '@/class/model/sys/User'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import { IataPrice } from '@/class/model/sys/IataPrice'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import SelectMawbDialog from './components/SelectMAWBDialog'
import TransitPortDialog from './components/TransitPortDialog'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { selectMawb, newConsole, attach, detch, changeMAWBNo } from '@/api/AirExport/airExportJob'
import { autoAllocateCargo } from '@/api/seaExport/warehouseIn'
import { validateReleaseNumberCustomer } from '@/api/company'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import selectOperationReqDialog from '@/components/Cargo/Job/selectOperationReqDialog'
import SelectSpecialOperationCodeDialog from '@/components/Cargo/Job/selectSpecialOperationCodeDialog'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import wareHouseDialog from './components/WarehouseDialog'
import soNoInput from '@/components/Cargo/Job/soNoInput'
import mawbNoInput from '@/components/Cargo/Job/mawbNoInput'
import sopDialog from '@/components/Cargo/Job/sopDialog'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import StampPictureView from '@/components/Cargo/Job/stampPictureView'
import stampIcon from '@/assets/stamp.jpg'
import { getLoading } from '@/utils/utilBaseElement'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import lang from '@/lang'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { multiply, mergeArray, dateCompare, handleBlur } from '@/utils/commonUtil'
import { FbaJob } from '@/class/model/booking/FbaJob'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import fbaBillAddressDialog from '@/views/cargo/v0/FBA/Order/billAddressDialog'
import {
  getCacheListByKey,
  getSpecificBasicDataFromCache
} from '@/utils/basicDataCache'
import StrUtils from '@/utils/StrUtils'
import { searchCustomerPrice } from '@/api/price/fbaQuotation'
import { FbaQuotationUtil } from '@/class/cargo/model/utils/FbaQuotationUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { Charge } from '@/class/model/act/Charge'
import BookingUtil from '@/class/cargo/model/utils/BookingUtil'
import { FbaQuotation } from '@/class/model/price/FbaQuotation'
import { getUserInfo } from '@/utils/auth'
import { getJobAvailableChannels } from '@/api/Fba/fbaChannel'
import { getAirlineList } from '@/api/partner/airline'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import { syncAtdInfoAE } from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearanceUtil'
import BookingAirUldDataGrid
  from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/components/bookingAirUldDataGrid'
import { UnitLoadDeviceUtil } from '@/class/cargo/model/utils/UnitLoadDeviceUtil'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
import DateUtils from '@/utils/dateUtils'
import { checkPoNoIsExist } from '@/api/booking/job'
import {
  ACTION_ADD, CHARGE_BUYING_AND_SELLING_PRICE, EXPORT_CONTROLLED_PRODUCT,
  LOG_AE_AIR_BOOKING, RATE_TYPE,
  SALES_CHANNEL_OCR_RECOGNITION, TAX_NATURES
} from '@/class/cargo/model/parameters/SystemConstants'
import { getPartnerByPoNo } from '@/api/projectManage/project'
import {
  CARGO_AIRCRAFT_ONLY, DD_STUFFY_TYPE, HANDLING_INFORMATION_ISP, HANDLING_INFORMATION_PAD, HANDLING_INFORMATION_PAS,
  HANDLING_INFORMATION_WPM,
  IS_WOOD,
  NON_WOOD,
  NONE, PASSENGER_AND_CARGO_AIRCRAFT, RETAIL_SALES,
  SPLIT_BUBBLE_COLLECT_ITEMS
} from '@/class/cargo/model/parameters/AirExportConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea.vue'
import { AutoComplete } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CommonDimensionsDialog from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/commonDimensionsDialog.vue'

export default {
  name: 'TabGeneral',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE':
          return lang.t('SeaExport.TUE')
        case 'WED':
          return lang.t('SeaExport.WED')
        case 'THU':
          return lang.t('SeaExport.THU')
        case 'FRI':
          return lang.t('SeaExport.FRI')
        case 'SAT':
          return lang.t('SeaExport.SAT')
        case 'SUN':
          return lang.t('Pricing.Sun')
        case 'MON':
        default:
          return lang.t('SeaExport.MON')
      }
    }
  },
  components: {
    CommonDimensionsDialog,
    cargoTextarea,
    BookingAirUldDataGrid,
    AutoNumberInput,
    NumberInput,
    cargoDepartmentSelect,
    SpecialRequestsGrid,
    cargoAdvanceSelect,
    StampPictureView,
    cargoContactsInfoDialog,
    cargoDepartmentNewSelect,
    cargoUserSelect,
    cargoOfficeSelect,
    cargoProjectSelect,
    TransitPortDialog,
    SelectMawbDialog,
    cargoCompanySelect,
    selectOperationReqDialog,
    cargoRichTextarea,
    cargoInput,
    billAddressDialog,
    wareHouseDialog,
    soNoInput,
    mawbNoInput,
    sopDialog,
    cargoPackingSelect,
    fbaBillAddressDialog,
    CargoSalesCompanySelect,
    SelectSpecialOperationCodeDialog
  },
  mixins: [BasicTabMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    pageSource: {
      type: String,
      required: false,
      defaultValue: ''
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    viewSource: {
      type: String,
      required: false,
      default: ''
    },
    isFba: { // 是否是FBA业务
      type: Boolean,
      default: false
    },
    provisionLock: {
      type: Object,
      default: () => ({ etdLocked: false, feeLocked: false })
    }
  },
  data() {
    return {
      handleBlur, AutoComplete,
      SPLIT_BUBBLE_COLLECT_ITEMS,
      WarehouseInState,
      AirExportConstants,
      isZh: this.$store.getters.language === 'zh',
      pm: new TabGeneralHP(this),
      selectMawbDialog: {
        visible: false,
        type: '',
        operateType: -1,
        carrierId: 0
      },
      transitPortDialog: {
        visible: false,
        job: null
      },
      TAX_NATURES,
      EXPORT_CONTROLLED_PRODUCT,
      selectTypeNames: TYPE_NAMES,
      showContactsInfoDialog: false,
      selectedLocalAddedService: [],
      localAddedService: [],
      selectedPodAddedService: [],
      podAddedService: [],
      job: new AirExportJob().fillDefaultValue().getData(),
      handlingInformationCode: '',
      tenantId: 0,
      channel4JobSelect: [],
      cargoType4JobSelect: [],
      fbaQuotation: null,
      fbaChannel: null,
      serviceChannel: null,
      chargingMethod: '',
      destinationDistribution: '',
      bubbleSplittingRatio: 0.0,
      bubbleCountingRatio: 0.0,
      txtSalesOffice: '', // 销售所在分公司
      contractStatuses: selectData.contractStatuses,
      contractStatusLabel: '', // 合约状态名称
      customerTip: '',
      overseaAgentUsersList: [], // 海外客服用户列表
      openProjectConfig: false,
      customerLevel: {
        level: '',
        customerName: ''
      },
      advancePaymentLabel: '', // 预付款(中邮)
      optStatusDefs: {
        edit: 'edit', // edit
        view: 'view' // 查看
      },
      currentOptStatus: 'view',
      officeList: [],
      config: {},
      creditOpen: false, // 是否开启信控
      sopConfigOpen: false,
      isHC: false,
      sopImageA: false,
      sopImageB: false,
      sopImageC: false,
      showWarningImageA: false,
      warningImageATip: '',
      showWarningImageB: false,
      warningImageBTip: '',
      showWarningImageC: false,
      warningImageCTip: '',
      sopPic,
      companyList: [],
      isNewDelegation: false,
      trustFromEditSales: false, // 交叉委托编辑销售
      salesList: null, // 销售数据源
      salesPrompt: '', // 销售悬浮提示
      contactList: [], // 联系人数据源
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      contractStatus: 0, // 合约状态
      branchOfficeCheck: false, // 分公司校验
      isWithinCloseAccountDate: false, // 关账控制
      showImperialButton: false, // 英制单位显示按钮
      isOpenImperial: false, // 是否开启英制单位
      originalImperial: false, // 是否开启英制单位
      mawbDoc: new AirCargoDoc().fillDefaultValue().getData(), // 主单
      hawbDoc: new AirCargoDoc().fillDefaultValue().getData(), // 分单
      iataPrice: new IataPrice().fillDefaultValue().getData(), // IATA运价
      mawbinfoDatas: null,
      isSc: false, // 新增业务时是否默认自揽货
      taskType: -1,
      detchMasterJob: null,
      mawbDetail: null, // 主单明细
      propertiesEnabled: {
        selectBtnEnabled: false,
        newConsoleBtnEnabled: false,
        attachBtnEnabled: false,
        deattachBtnEnabled: false,
        mblEnabled: false,
        bookingTermEnabled: false,
        expressEnabled: true
      },
      allocate: false,
      addrPM: new BillAddressCommonPM(this),
      loading3Code: '', // 装货港三字码
      destination3Code: '', // 目的港三字码
      selectOperationReqDialog: { // 操作要求
        visible: false,
        value: ''
      },
      selectSpecialOperationCodeDialog: {
        visible: false,
        value: ''
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0
        },
        hasHandlingInformation: false
      },
      sopDialog: {
        visible: false,
        cmpIdx: 0,
        agent: '',
        contactList: []
      },
      billAddressDialog: {
        visible: false,
        job: null,
        params: {}
      },
      warehouseDialog: {
        visible: false,
        job: {}
      },
      vesselLine: '',
      fbaBillAddressDialog: { // Fba收发通地址
        visible: false
      },
      stampIcon, // 订舱章
      stampPictureView: {
        businessDocuments: [], // 不为空则显示订舱章
        visible: false
      },
      dimensionsDialog: {
        dimension: '',
        type: 0,
        visible: false
      },
      oldCarrierId: 0, // 记录原始的航空公司Id
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      salesCanSeeBookingAgent: false,
      fbaJob: new FbaJob().fillDefaultValue().getData(), // fbaJob
      FbaJobConstants,
      JobUtils,
      airUlds: [],
      loadingPortChanged: false, // 起运港是否发生变更
      oldMbl: '', // 旧主单号
      poNoRed: false,
      needConfirmProjectNo: false,
      isProjectLinkedCustomer: false,
      splitBubbleCollectionFormat: false, // 分泡收取格式
      pbProportionCheck: false,
      pbProportion2Check: false,
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        userDefinedRole3: null,
        userDefinedRole4: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      cargoSalesList: null,
      showMarkOrCargoEnglishNameDialog: false, // 英文品名唛头是否双击展示
      rateType: RATE_TYPE,
      markChange: false,
      cargoEnglishNameChange: false,
      secondaryCustomJobTypeList: [],
      customJobTypeList: [],
      oldMark: '',
      oldCargoEnglishName: '',
      isZY: false, // 显示中邮选项
      editMawblNoMode: 0, // CARGO-46018 新增配置项
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      syncCustomerShippingInfoBothBolAndBasicTab: false,
      syncCustomerShippingInfoBothBolAndBasicTabAll: false,
      airlineProductDownList: [], // 航线产品 下拉
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      temperatureRequirementDownList: [], // 温控要求 下来
      isShowContactPersonDetail: false // 海创显示详细信息
    }
  },
  computed: {
    SystemConstants() {
      return SystemConstants
    },
    provisionEtdLocked() {
      return !!(this.provisionLock && this.provisionLock.etdLocked)
    },
    openImperial() {
      if (this.viewStatus) {
        return this.isOpenImperial
      } else {
        return this.originalImperial
      }
    },
    // 是否为空运订舱页面
    isAeBooking() {
      return this.$route.path.toLowerCase() === '/AirExport/AeBooking'.toLowerCase() || this.$route.path.toLowerCase() === '/FBA/FBAAeBooking'.toLowerCase()
    },
    viewStatus() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    showDialog() {
      // 判断 如果是handleInformation 弹框不可操作
      if (this.advanceTextDialog.hasHandlingInformation) {
        return true
      }
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    editStatus() {
      return this.optStatusDefs.edit === this.currentOptStatus
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    customerEnabled() {
      // 开启参数1 且是被委托的业务，不可以改委托单位；
      if (this.isNewDelegation && this.job.trustFromJob) {
        return false
      }
      return !this.viewStatus && (this.trustFromEditSales ? true : !this.job.relatedJob) && SecurityUtil.checkOffsetAutoCompleteEnabled(this.job, 'customerId')
    },
    designationAgentEnabled() {
      return !this.viewStatus && SecurityUtil.checkOffsetAutoCompleteEnabled(this.job, 'designationAgent')
    },
    saleEnabled() {
      return !this.viewStatus && ((this.pm.trustFromEditSales ? true : !this.job.trustFromJob)) && !this.isWithinCloseAccountDate
    },
    opDeptEnabled() {
      return !this.viewStatus && !this.isWithinCloseAccountDate
    },
    destinationAgentEnabled() {
      return !this.viewStatus && SecurityUtil.checkOffsetAutoCompleteEnabled(this.job, 'designationAgent')
    },
    operateTypeEnable() {
      return !this.job.express && !(this.job.lclMasterUuid && !this.job.uuid)
    },
    bookingAgentEnabled() {
      return !this.viewStatus && !this.job.lclMasterUuid && SecurityUtil.checkOffsetAutoCompleteEnabled(this.job, 'bookingAgent')
    },
    airlineCompanyEnabled() {
      return !this.viewStatus && !this.job.lclMasterUuid && SecurityUtil.checkOffsetAutoCompleteEnabled(this.job, 'carrierId')
    },
    flightEnabled() {
      return !this.viewStatus && !this.job.lclMasterUuid
    },
    destinations() { // 目的地 可选项
      return JobUtils.initDestination(this.fbaQuotation)
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    showChannelNo() {
      return ['B2B', this.$t('Menu.WallTechFamily')].includes(this.job.salesChannel)
    },
    isCopy() {
      return this.action === 'copy'
    },
    // 销售分公司
    salesOffice() {
      return this.job.salesOffice
    },
    /**
     * CARGO-46018 友邦：空运订舱中主单号只能通过主单管理维护的单号进行选择
     * 0–自由编辑，可手动输入也可选择主单号列表
     * 1–友邦模式，当订舱性质=自订舱时，输入框置灰，只能通过选择列表主单号。否则可自由编辑，可手动也可列表选择
     */
    isEditablemawbNoInput() {
      return !(this.propertiesEnabled.mblEnabled && (this.editMawblNoMode === 0 || !(this.editMawblNoMode === 1 && this.job.bookingTerm === BookingTerm.SB_BOOKING_TYPE.code)))
    },
    importDifferenceField() {
      return this.job.differenceJobFields || {}
    }
  },

  watch: {
    'job.customerId'(newVal) {
      if (this.job.fba && this.fbaJob) {
        this.fbaJob.customerId = newVal
      }
    }
  },
  async created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
    this.context.loading = true
    const loading = getLoading()
    await cache.load(cacheName.OFFICE_LIST, cacheName.CONFIG).finally(() => {
      this.context.loading = false
      loading.close()
    })
    this.officeList = cache.officeList
    this.config = cache.config
    this.isNewDelegation = Number(this.config.get('isNewDelegation')) === 1
    this.isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    this.creditOpen = Number(this.config.get('creditOpen')) === 1
    this.trustFromEditSales = Number(this.config.get('TrustFromEditSales')) === 1
    this.salesOfficeCheck = Number(this.config.get('SalesOfficeCheck')) === 1
    this.openProjectConfig = Number(this.config.get('openProjectConfig')) === 1
    this.isAddUserDefinedRoles = Number(this.config.get('IsAddUserDefinedRoles')) === 1
    this.salesCanSeeBookingAgent = Number(this.config.get('SalesCanSeeBookingAgent')) === 1
    this.needConfirmProjectNo = Number(this.config.get('needConfirmProjectNo')) === 1
    this.isProjectLinkedCustomer = Number(this.config.get('isProjectLinkedCustomer')) === 1 // 项目是否和委托单位关联
    this.splitBubbleCollectionFormat = Number(this.context.config.get('SplitBubbleCollectionFormat')) === 1
    this.isZY = String(this.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
    this.isShowContactPersonDetail = String(this.context.config.get('ToExoSystem')) === 'HC'
    this.editMawblNoMode = Number(this.context.config.get('EditMawblNoMode'))
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.syncCustomerShippingInfoBothBolAndBasicTabAll = Number(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 0 || Number(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1 || (Number(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 2 && this.view.action === 'add')
    this.pm.init()
    this.markChange = false
    this.cargoEnglishNameChange = false
  },
  beforeMount() {
  },
  methods: {
    txtCargoInformationChangeHandler(obj) {
      this.setJobSelectValue(obj)
      this.job.cargoName = obj.englishName || ''
    },
    setTransferingHandler() {
      this.transitPortDialog.visible = true
      this.transitPortDialog.job = this.job
    },
    checkEnableBindMAWB() {
      if (this.job.mbl && this.job.mbl.length > 0 && !this.job.mblOnly) {
        this.$message.warning(this.$t('queryJob.TheBeenAddedToOrder'), this.$t('FileHistory.Tips'))
        return false
      }
      return true
    },
    openMAWBHandler() {
      if (this.checkEnableBindMAWB()) {
        if (this.job.mblOnly && this.job.bookingTerm === 'DB') {
          this.selectMawbDialog.type = 'input'
        } else {
          this.selectMawbDialog.type = 'select'
        }
        this.selectMawbDialog.carrierId = this.job.carrierId
        this.selectMawbDialog.operateType = -1
        this.selectMawbDialog.visible = true
      }
    },
    newConsoleHandler() {
      if (this.checkEnableBindMAWB()) {
        this.selectMawbDialog.type = 'new'
        this.selectMawbDialog.operateType = -1
        this.selectMawbDialog.visible = true
      }
    },
    attachMAWBHandler() {
      if (this.checkEnableBindMAWB()) {
        this.selectMawbDialog.type = 'attach'
        this.selectMawbDialog.operateType = this.job.operateType
        this.selectMawbDialog.visible = true
      }
    },
    async deattachMAWBHandler() {
      const hasSharedCharge = await new AirExportJob(this.job).checkShareCharge()
      if (!this.job.uuid) {
        this.job.mbl = null
        this.pm.checkMAWBRelationState()
        return
      } else if (!this.job.mbl && !this.job.lclMasterUuid) {
        this.$message.warning(this.$t('queryJob.NotBoundYet'), this.$t('FileHistory.Tips'))
        return
      } else if (!this.job.lclMasterUuid && this.job.mbl && this.job.operateType === 0) {
        this.job.mbl = null
        this.pm.checkMAWBRelationState()
        return
      } else if (hasSharedCharge) {
        this.$message.warning(this.$t('queryJob.TheCostSharingAndSeparated'), this.$t('FileHistory.Tips'))
        return
      }
      this.$confirm(this.$t('queryJob.AreUnbindTheMasterOrder'), this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('constant.yes'),
        cancelButtonText: this.$t('constant.no'),
        type: 'info'
      }).then(() => {
        let location = null
        if (!this.isFba) {
          location = LOG_AE_AIR_BOOKING.code
        }
        detch({ jobKey: this.job.uuid, location: location }).then(res => {
          if (res.data) { // 调用后端方法，修改job属性，返回后更新对应的修改字段
            this.job.mbl = null
            this.job.express = false
            this.job.version = res.data.version
            this.pm.checkMAWBRelationState()
            if (this.job.lclMasterUuid) {
              this.$emit('detchJobFromMaster', [this.job.lclMasterUuid])
            }
          }
        })
      }).catch(() => false)
    },
    bubbleCountingChange() {
      if (this.job.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.BubbleCountingRatio')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.job.bubbleCountingRatio = this.bubbleCountingRatio
      } else {
        if (this.fbaJob.bubbleCountingRatio > 9999) {
          this.fbaJob.bubbleCountingRatio = 9999
          this.bubbleCountingRatio = 9999
        } else {
          this.bubbleCountingRatio = this.fbaJob.bubbleCountingRatio
        }
      }
    },
    // 选择主单号回调事件
    selectedMAWBHandler(data = null) {
      this.selectMawbDialog.visible = false
      if (data) {
        const type = this.selectMawbDialog.type
        const job = this.job
        if (type === 'select' || type === 'input') {
          this.mawbDetail = data
          if (!this.job.uuid) {
            this.taskType = -1
            job.mbl = data.mawbNo
            this.pm.checkMAWBRelationState()
          } else {
            this.selectMAWB()
          }
        } else if (type === 'new') {
          this.mawbDetail = data
          if (!job.uuid) {
            this.taskType = 2
            job.mbl = data.mawbNo
            this.pm.checkMAWBRelationState()
          } else {
            this.newConsole()
          }
        } else if (type === 'attach') {
          this.mawbDetail = data
          if (!job.uuid) {
            this.taskType = 3
            job.mbl = data.mawbNo
            this.pm.checkMAWBRelationState()
          } else {
            this.attachMAWB()
          }
        } else if (type === 'input') {
          if (!job.uuid) {
            this.taskType = 3
            job.mbl = data
          } else {
            changeMAWBNo({ 'jobKey': this.job.uuid, 'mawbDetailUuid': null, 'mawbNo': data }).then(res => {
            })
          }
        }
      }
    },
    setJobSelectValue(obj) {
      // 到货方式 校验 原先是【门点提货】的需要校验
      if (this.job.uuid && obj.key === 'loadingTerm' && this.job[obj.key] === AirExportConstants.DD_STUFFY_TYPE.code) {
        // 只要 有一个绑定了【车单】，则不允许编辑【到货方式】
        if (this.job.trucking && this.job.trucking.length > 0) {
          const row = this.job.trucking.find(p => !!p.carFormUuid)
          if (row) {
            this.$message.warning(this.$t('CargoMsg.Cargo_DispatchTaskLinkedToVehicle_ArrivalMethod'))
            this.$refs.loadingTerm.initComponent(false)
            return
          }
        }
      }
      this.job[obj.key] = obj.value
    },
    dischargingPortDoorClick() {
      const originDischargingPortDoor = !this.job.dischargingPortDoor
      // 只要 有一个绑定了【车单】，则不允许编辑【目的港派车】
      if (this.job.uuid && originDischargingPortDoor && this.job.dischargingTrucking && this.job.dischargingTrucking.length > 0) {
        const row = this.job.dischargingTrucking.find(p => !!p.carFormUuid)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DispatchTaskLinkedToVehicle_DestinationPort'))
          // 还原
          this.job.dischargingPortDoor = originDischargingPortDoor
          return
        }
      }
    },
    oncustomJobTypeChange(obj) {
      this.job[obj.key] = obj.value
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
      this.job.secondaryCustomJobType = ''
      this.setSecondaryCustomJobTypeFunc()
      this.contractRuleFieldChange(this.job.customerId, this.job.designationAgent)
    },
    setSecondaryCustomJobTypeFunc() {
      if (this.job.customJobType) {
        this.secondaryCustomJobTypeList = JobUtils.setSecondaryCustomJobTypeList(this.job.customJobType, this.job.lob)
      } else {
        this.secondaryCustomJobTypeList = []
      }
    },
    setCustomJobTypeFunc() {
      this.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.operateType, this.job.fba)
    },
    onWoodOrNotWoodChagne(newValue) {
      this.job.wood = newValue.value
      JobUtils.onWoodOrNotWoodChagne(this.job)
    },
    onHazardousGoodsOptionChagne(newValue) {
      this.job.hazardousGoodsOption = newValue.value
      JobUtils.onHazardousGoodsOptionChagne(this.job)
    },

    async onShow(row, isRefresh) {
      if (!row.uuid) {
        row.booking = true
      }
      if (!isRefresh) {
        this.mawbDoc = await new AirExportJob(row).getCargoDoc(CargoDocConsts.MAWB, false)
        this.hawbDoc = await new AirExportJob(row).getCargoDoc(CargoDocConsts.HAWB, false)
        return
      }
      this.fbaQuotation = null
      this.fbaChannel = null
      this.serviceChannel = null
      this.cargoType4JobSelect = []
      this.localAddedService = []
      this.podAddedService = []
      this.selectedLocalAddedService = []
      this.selectedPodAddedService = []
      // 初始化动态变量值
      this.salesList = null
      this.salesPrompt = ''
      this.taskType = -1
      this.oldCarrierId = 0
      this.mawbinfoDatas = null
      this.overseaAgentUsersList = []
      this.stampPictureView.businessDocuments = []
      this.loadingPortChanged = false
      row.atdChanged = false
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      this.job = row
      this.oldMbl = this.job.mbl
      this.airUlds = this.job.airUld || []
      this.oldMark = this.job.mark || ''
      this.oldCargoEnglishName = this.job.cargoEnglishName || ''
      // handling information
      if (this.job.handlingInformation) {
        this.job.handlingInformationCode = this.job.handlingInformation
        await JobUtils.getHandlingInformationName(this.job)
      }
      await this.pm.fillView()
      JobUtils.setSailingDay(this.job)
      // fba
      if (this.isEdit && this.job.fba) {
        await getJobAvailableChannels({ tenantId: this.tenantId }).then(res => {
          this.channel4JobSelect = res.data.filter(e => e.shippingType === 'AE')
        })
      }
      if (this.job.fba) {
        if (this.job.uuid || this.job.fbaJob) {
          this.fbaJob = this.job.fbaJob
        } else {
          this.fbaJob = new FbaJob().fillDefaultValue().getData()
          this.fbaJob.bubbleCountingRatio = 6000.0
        }
        this.bubbleCountingRatio = this.fbaJob.bubbleCountingRatio
        this.chargingMethod = this.fbaJob.chargingMethod
        this.destinationDistribution = this.fbaJob.destinationDistribution
        this.bubbleCountingRatio = this.fbaJob.bubbleCountingRatio
        this.bubbleSplittingRatio = this.fbaJob.bubbleSplittingRatio
        await this.changeChannelName(this.job.serviceChannel)
        this.serviceChannel = this.job.serviceChannel
        this.getCargoType()
        // 初始化增值服务
        let valueAddedServices = []
        if (this.fbaJob.valueAddedServices && this.fbaJob.valueAddedServices.split(',').length > 0) {
          valueAddedServices = this.fbaJob.valueAddedServices.split(',')
        }
        const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_ValueAddedService)
        for (const item of res) {
          if (item.fbaAir) {
            switch (Number(item.serviceType)) {
              case 0:
                this.localAddedService.push(item)
                if (valueAddedServices.indexOf(item.code) >= 0) {
                  this.job[item.code] = true
                  this.selectedLocalAddedService.push(item.code)
                }
                break
              case 1:
                this.podAddedService.push(item)
                if (valueAddedServices.indexOf(item.code) >= 0) {
                  this.job[item.code] = true
                  this.selectedPodAddedService.push(item.code)
                }
                break
            }
          }
        }
      } else {
        this.cargoType4JobSelect = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType).filter(p => p.air)
      }
      if (!this.isEdit && this.job.poNo && this.needConfirmProjectNo && !this.openProjectConfig) {
        this.poNoRed = await checkPoNoIsExist(this.job.poNo, this.job.uuid).then(res => res.data) > 0
      }
      this.pbProportionCheck = false
      this.pbProportion2Check = false
      this.setSecondaryCustomJobTypeFunc()
      this.setCustomJobTypeFunc()
      if (this.action === 'add') {
        this.job.serviceProduct = AirExportConstants.RETAIL_SALES.code
      }
      if (this.action === 'copy' && !this.job.serviceProduct) {
        this.job.serviceProduct = AirExportConstants.RETAIL_SALES.code
      }

      JobUtils.loadCompanyCargoSales(this, this.job, this.pm.isSpecifiedSalesBusiness)

      // CARGO-48635 OCR识别 创建业务时，调用委托单位带出逻辑
      if (!this.job.uuid && this.action === ACTION_ADD.code && this.job.salesChannel === SALES_CHANNEL_OCR_RECOGNITION.code) {
        const company = await Company.getCompanyById(this.job.customerId)
        if (company) {
          this.customerIdChange2ContractHandler(company)
        }
        const carrier = await Company.getCompanyById(this.job.carrierId)
        if (carrier) {
          this.pm.airlineCompanyChangeHandler(carrier.cmpIdx)
          this.pm.airlineCompanyChange(carrier.cmpIdx)
          this.pm.airlineCompanyCheckHandler(carrier.cmpIdx)
        }
      }
      if (this.$store.getters.enableFrontEndPlugin) {
        this.setUserDefinedRoleDataUI()
      }
    },
    // 委托单位改变
    async customerIdChange2ContractHandler(company) {
      this.showWarningImageB = false
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatus = 0
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.contactList = []
      this.salesList = null
      this.cargoSalesList = null
      this.job.customerContact = ''
      this.job.editCftMode = false
      this.stampPictureView.businessDocuments = []
      if (this.job.customerId && parseInt(this.job.customerId) > 0) {
        this.job.preCustomerId = this.job.customerId
      }
      if (!company.cmpIdx) {
        this.job.customerId = 0
        if (this.salesOfficeCheck) {
          this.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, this.$store.getters.currentOfficeId, true)
        } else {
          this.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, null, true)
        }
        return
      }
      const validateRes = await validateReleaseNumberCustomer({
        companyId: company.cmpIdx,
        officeId: this.$store.getters.currentOfficeId
      })
      if (validateRes && validateRes.data && validateRes.data.allowed === false) {
        if (validateRes.data.message) {
          this.$message.warning(validateRes.data.message)
        }
        this.job.customerId = 0
        console.log('[ReleaseNumber] AE tabGeneral clear', !!this.$refs.customerSelect)
        if (this.$refs.customerSelect && this.$refs.customerSelect.clear) {
          this.$refs.customerSelect.clear()
        }
        return
      }
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
      if (blacklist) {
        // return
      }
      // 欧坚委托单位是否风险客户
      await JobUtils.checkRiskyCustomersByByCustomerId(company.cmpIdx, StrUtils.isEmpty(this.job.uuid))
      SEUtils.refreshChargeAccountId(this.job, 'customerId', this.$t('SeaExport.ConsignationCompany'), this.context.modifiedData, () => {
        this.context.reloadCharge = true
      }) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
      this.job.customerId = company.cmpIdx

      company = new Company(company)
      if (this.creditOpen) {
        this.pm.checkCreditByCompany(company.cmpIdx, 1)
        this.pm.checkNewJobCreditInfo()
      }
      const isForbid = await Contract.isContractExpiredForbidCreateJob(company.cmpIdx)
      if (isForbid) {
        this.job.customerId = 0
        this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
        return
      }

      // 合同限制校验：检查是否启用合同限制且可放号天数<=0
      const contractLimitEnabled = company.contractLimitEnabled
      const availableDays = company.availableReleaseDays

      // contractLimitEnabled 可能是 '1' 或 1
      if (contractLimitEnabled === '1' || contractLimitEnabled === 1) {
        // availableReleaseDays 可能是数字或字符串，需要转换
        const daysNum = parseInt(availableDays) || 0
        if (daysNum <= 0) {
          const companyName = company.chineseName || company.englishName || '该委托单位'
          this.$message.warning(`${companyName} 未上传合同/合同失效，无法放号，请联系客户管理人员`)
          this.job.customerId = 0
          if (this.$refs.customerSelect && this.$refs.customerSelect.clear) {
            this.$refs.customerSelect.clear()
          }
          return
        }
      }

      if (company.incoTerm) {
        const incoTerm = company.incoTerm.split(',')
        if (incoTerm.length > 0) {
          this.job.incoTerm = incoTerm[0]
        }
      }
      this.pm.getContractStatus(company) // 获取合约状态
      await this.pm.loadCustomerDetail() // 加载客户详情
      this.pm.loadCustomerLevel() // 加载客户类型
      this.pm.loadCustomerContacts() // 加载联系人
      this.pm.loadCompanyUser() // 加载业务的服务人员
      if (this.fbaJob.serviceChannel && this.job.cWeight && this.job.cWeight > 0) {
        await this.$confirm(this.$t('FbaJob.changeCustomer'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          // 刷新费用
          this.refreshCharge()
        }).catch(() => {
        })
      }
      JobUtils.loadCompanyCargoSales(this, this.job, this.pm.isSpecifiedSalesBusiness, true)
    },
    getCargoType() {
      this.cargoType4JobSelect = []
      const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType)
      let acceptableGoods = []
      if (this.fbaQuotation) {
        acceptableGoods = this.fbaQuotation.acceptableGoods.split(',')
      }
      for (const item of res) {
        if (this.fbaQuotation) {
          const valid = acceptableGoods && acceptableGoods.length > 0 && acceptableGoods.indexOf(item.code) > -1
          if (!valid) {
            continue
          }
        }
        if (item.fbaAir) {
          this.cargoType4JobSelect.push(item)
        }
      }
      if (this.job.cargoType && this.cargoType4JobSelect.map(item => item.code).indexOf(this.job.cargoType) === -1) {
        this.job.cargoType = ''
      }
    },
    // 更改服务渠道
    async changeServiceChannel(channel) {
      if (!channel) {
        this.serviceChannel = null
        this.fbaChannel = null
        this.fbaQuotation = null
        this.job.fbaChannel = this.fbaChannel
        this.job.fbaQuotation = this.fbaQuotation
        return
      }
      let update = false
      let refreshCharge = false
      if (typeof this.job.customerId === 'number' && this.job.customerId > 0) {
        await this.changeChannelName(channel)
        const containCustomer = await this.checkChangeChannel()
        if (containCustomer) {
          if (typeof this.fbaJob.warehouseCode === 'string' && this.fbaJob.warehouseCode) {
            // 判断区中是否包含该目的地
            if (this.checkWarehouseCode()) {
              // 判断计费重量是否有值
              if (this.job.customerId && this.job.cWeight && this.job.cWeight > 0) {
                await this.$confirm(this.$t('FbaJob.refreshCharge'), this.$t('Message.Tips'), {
                  confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                  cancelButtonText: this.$t('CargoMsg.Cargo_No'),
                  type: 'warning'
                }).then(() => {
                  refreshCharge = true
                }).catch(() => {
                })
              }
            } else {
              await this.$alert(StrUtils.substitute(this.$t('FbaJob.cargoTypeNotExist'), this.job.warehouseCode), this.$t('Message.Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                type: 'warning'
              })
              this.job.warehouseCode = ''
            }
          }
          update = true
        } else {
          await this.$confirm(this.$t('FbaJob.changeChannel'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
            cancelButtonText: this.$t('CargoMsg.Cargo_No'),
            type: 'warning'
          }).then(async() => {
            update = true
            if (!this.checkWarehouseCode()) {
              this.job.warehouseCode = ''
            }
          }).catch(async() => {
            this.fbaJob.serviceChannel = this.serviceChannel
            await this.changeChannelName(this.serviceChannel)
            return Promise.reject(this.$t('Message.EditCancelled'))
          })
        }
      } else {
        if (typeof this.job.warehouseCode === 'string' && this.job.warehouseCode) {
          // 判断区中是否包含该目的地
          if (!this.checkWarehouseCode()) {
            await this.$alert(StrUtils.substitute(this.$t('FbaJob.cargoTypeNotExist'), this.job.warehouseCode), this.$t('Message.Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
              type: 'warning'
            })
            this.job.warehouseCode = ''
          }
        }
        update = true
      }
      if (update) {
        this.serviceChannel = channel
        await this.changeChannelName(channel)
        this.fbaJob.serviceChannel = channel
        await this.checkCargoType()
        if (this.fbaChannel) {
          this.syncJobInfoByChannel()
        }
        this.getCargoType()
      }
      if (refreshCharge) {
        // 刷新费用
        await this.refreshCharge()
      }
    },
    // 更新渠道同步业务字段
    syncJobInfoByChannel() {
      this.fbaJob.chargingMethod = this.fbaChannel.chargingMethod + ''
      this.fbaJob.destinationDistribution = this.fbaChannel.destinationDistribution + ''
      this.fbaJob.bubbleCountingRatio = this.fbaChannel.bubbleCountingRatio
      this.fbaJob.bubbleSplittingRatio = this.fbaChannel.bubbleSplittingRatio
      this.chargingMethod = this.fbaJob.chargingMethod
      this.destinationDistribution = this.fbaJob.destinationDistribution
      this.bubbleCountingRatio = this.fbaJob.bubbleCountingRatio
      this.bubbleSplittingRatio = this.fbaJob.bubbleSplittingRatio
    },
    // 更改目的地
    async changeWarehouseCode() {
      if (this.job.customerId && this.fbaJob.serviceChannel && this.job.cWeight && this.job.cWeight > 0) {
        await this.$confirm(this.$t('FbaJob.changeWarehouseCode'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          // 刷新费用
          this.refreshCharge()
        }).catch(() => {
        })
      }
    },
    // 刷新费用
    async refreshCharge() {
      let authorizationValue = null
      let customers = []
      // 查找对应运价级别的客户
      for (const e of this.fbaQuotation.customerPriceList) {
        const item = { anyInteger: e.quotationObject }
        await searchCustomerPrice(item).then(res => {
          const result = res.data || []
          customers = customers.concat(result)
        })
      }
      if (customers && customers.length > 0) {
        for (const customer of customers) {
          if (Number(this.job.customerId) === Number(customer.CMP_IDX)) {
            authorizationValue = customer.AUTHORIZATION_VALUE
            break
          }
        }
      }
      if (authorizationValue) {
        const params = {
          fbaChannel: this.fbaChannel,
          fbaQuotation: this.fbaQuotation,
          quantity: this.job.quantityActual,
          weight: this.job.weightActual,
          cubage: this.job.cubageActual,
          volumetricWeight: this.job.volumetricWeight,
          chargeWeight: Number(this.job.cWeight),
          warehouseCode: this.fbaJob.warehouseCode,
          authorizationValue: authorizationValue
        }
        const fbaChargeInfo = FbaQuotationUtil.getFbaChargeInfo(params)
        if (fbaChargeInfo) {
          fbaChargeInfo.authorizationValue = authorizationValue
        }
        const fbaAdditionalChargeInfo = FbaQuotationUtil.getFbaAdditionalChargeInfo(params)
        if (fbaAdditionalChargeInfo) {
          fbaAdditionalChargeInfo.authorizationValue = authorizationValue
        }
        if (this.job.charges && this.job.charges.length > 0) {
          let matchCharge = false
          const chargeList = []
          let matchAdditionalCharge = false
          const additionalChargeList = []
          for (const item of this.job.charges) {
            if (fbaChargeInfo) {
              const chargeItemId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'zhName', '空运费', 'itemId')
              if (item.chargeItemId === chargeItemId) {
                matchCharge = true
                chargeList.push(item)
              }
            }
            if (fbaAdditionalChargeInfo) {
              const chargeItemList = getCacheListByKey(basicCacheKeys.basic_data_ChargeItem)
              const matchList = chargeItemList.filter(p => (item.chargeItemId === p.itemId) && p.surcharge)
              if (matchList && matchList.length > 0) {
                matchAdditionalCharge = true
                additionalChargeList.push(item)
              }
            }
          }
          if (matchCharge) {
            this.updateCharge(fbaChargeInfo, chargeList)
          } else {
            await this.createCharge(fbaChargeInfo)
          }
          if (matchAdditionalCharge) {
            this.updateCharge(fbaAdditionalChargeInfo, additionalChargeList, true)
          } else {
            await this.createCharge(fbaAdditionalChargeInfo, true)
          }
        } else {
          if (fbaChargeInfo) {
            await this.createCharge(fbaChargeInfo)
          }
          if (fbaAdditionalChargeInfo) {
            await this.createCharge(fbaAdditionalChargeInfo, true)
          }
        }
      }
    },
    // 更新费用
    updateCharge(fbaChargeInfo, chargeList, additional = false) {
      for (const item of chargeList) {
        if (!item.confirmBillUuid &&
            !item.invoiceUuid && !item.billingUuid && !item.billingPaymentUuid &&
            !item.verifiedAmount && !item.paidOff && item.chargeState === 0 &&
            ((item.receivable && this.job.receivableChargeLockedStatus === 0) || (!item.receivable && this.job.payableChargeLockedStatus === 0))) {
          if (fbaChargeInfo) {
            item.chargeItemId = fbaChargeInfo.chargeItemId
            item.currency = fbaChargeInfo.currency
            item.quantity = fbaChargeInfo.quantity
            item.unitRate = fbaChargeInfo.unitRate
            item.amount = fbaChargeInfo.amount
            item.excludingTaxAmount = fbaChargeInfo.excludingTaxAmount
            item.measure = fbaChargeInfo.measure
            item.accountId = this.job.customerId
            ChargeUtils.calculateTax(item, item.quantity * item.unitRate, item.taxRate, true)
            ChargeUtils.getChargeisOverseaNotControlledByConfig(item)
            const localCurrency = RateUtil.localCurrencyByOffice()
            let remarks = ''
            if (additional) {
              remarks = '服务渠道：' + this.fbaJob.serviceChannel + '\n' +
                  '费用类型：' + fbaChargeInfo.calcMethodStr + '\n' +
                  '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
                  '折合' + localCurrency + '：' + item.excludingTaxAmount
            } else {
              remarks = '服务渠道：' + this.fbaJob.serviceChannel + '\n' +
                  '运价级别：' + ColumnUtils.QuotationObjectLabelFunc(Number(fbaChargeInfo.authorizationValue)) + '\n' +
                  '计费重量：' + this.job.cWeight + '\n' +
                  '计算方式：' + fbaChargeInfo.calcMethodStr + '\n' +
                  '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
                  '折合' + localCurrency + '：' + item.excludingTaxAmount
            }
            item.remarks = remarks
          }
        }
      }
      if (this.job.api) {
        this.job.api.refreshCells({ force: true })
      }
    },
    // 新增费用
    async createCharge(fbaChargeInfo, additional = false) {
      if (fbaChargeInfo) {
        const charge = new Charge().fillDefaultValue().getData()
        charge.chargeItemId = fbaChargeInfo.chargeItemId
        charge.currency = fbaChargeInfo.currency
        charge.quantity = fbaChargeInfo.quantity
        charge.unitRate = fbaChargeInfo.unitRate
        charge.amount = fbaChargeInfo.amount
        charge.excludingTaxAmount = fbaChargeInfo.excludingTaxAmount
        charge.measure = fbaChargeInfo.measure
        charge.accountId = this.job.customerId
        await BookingUtil.getNewCharge(charge, this.job, true)
        ChargeUtils.getChargeisOverseaNotControlledByConfig(charge)
        const localCurrency = RateUtil.localCurrencyByOffice()
        let remarks = ''
        if (additional) {
          remarks = '服务渠道：' + this.fbaJob.serviceChannel + '\n' +
              '费用类型：' + fbaChargeInfo.calcMethodStr + '\n' +
              '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
              '折合' + localCurrency + '：' + charge.excludingTaxAmount
        } else {
          remarks = '服务渠道：' + this.fbaJob.serviceChannel + '\n' +
              '运价级别：' + ColumnUtils.QuotationObjectLabelFunc(Number(fbaChargeInfo.authorizationValue)) + '\n' +
              '计费重量：' + this.job.cWeight + '\n' +
              '计算方式：' + fbaChargeInfo.calcMethodStr + '\n' +
              '预估金额：' + fbaChargeInfo.estimatedAmountStr + '\n' +
              '折合' + localCurrency + '：' + charge.excludingTaxAmount
        }
        charge.remarks = remarks
        this.context.reloadCharge = true
      }
    },
    // 判断区中是否包含该目的地
    checkWarehouseCode() {
      let result = false
      if (this.fbaQuotation) {
        const partitionSettingList = this.fbaQuotation.partitionSettingList
        let warehouseCode = []
        for (const item of partitionSettingList) {
          const pod = item.pod
          if (pod && pod.split(',').length > 0) {
            warehouseCode = warehouseCode.concat(pod.split(','))
          }
        }
        result = warehouseCode.indexOf(this.fbaJob.warehouseCode) > -1
      }
      return result
    },
    // 判断可接货物是否包含当前货物类型
    async checkCargoType() {
      const acceptableGoodsStr = this.fbaQuotation.acceptableGoods
      let acceptableGoods = []
      if (acceptableGoodsStr && acceptableGoodsStr.split(',').length > 0) {
        acceptableGoods = acceptableGoodsStr.split(',')
      }
      if (acceptableGoods.indexOf(this.job.cargoType) === -1 && this.job.cargoType) {
        const acceptableGoodsTag = ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_CargoType, 'code', this.job.cargoType, 'chineseName')
        await this.$alert(StrUtils.substitute(this.$t('FbaJob.cargoTypeNotExist'), acceptableGoodsTag), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.job.cargoType = ''
      }
    },
    // 判断是否更新渠道
    async checkChangeChannel() {
      let customers = []
      let containCustomer = false
      // 查找对应运价级别的客户
      if (this.fbaQuotation) {
        for (const e of this.fbaQuotation.customerPriceList) {
          const item = { anyInteger: e.quotationObject }
          await searchCustomerPrice(item).then(res => {
            const result = res.data || []
            customers = customers.concat(result)
          })
        }
        if (customers && customers.length > 0) {
          for (const customer of customers) {
            if (Number(this.job.customerId) === Number(customer.CMP_IDX)) {
              containCustomer = true
              break
            }
          }
        }
      }
      return containCustomer
    },
    async changeChannelName(channelName) {
      const channel = this.channel4JobSelect.find(e => channelName === e.channelName)
      if (channel) {
        this.fbaChannel = channel
        this.fbaQuotation = new FbaQuotation().fillDefaultValue().getData()
        this.fbaQuotation.uuid = channel.quotationUuid
        const jobModel = new FbaQuotation(this.fbaQuotation)
        await jobModel.loadFbaQuotationRelated({
          quotation: true,
          label: true,
          partitionSetting: true,
          setupSetting: true,
          charge: true,
          customerPrice: true
        })
        this.job.fbaChannel = this.fbaChannel
        this.job.fbaQuotation = this.fbaQuotation
      } else {
        this.fbaChannel = null
        this.fbaQuotation = null
        this.job.fbaChannel = this.fbaChannel
        this.job.fbaQuotation = this.fbaQuotation
      }
    },
    bubbleSplittingRatioChange() {
      if (this.fbaJob.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.BubbleSplittingRatio')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.fbaJob.bubbleSplittingRatio = this.bubbleSplittingRatio
      } else {
        if (this.fbaJob.bubbleSplittingRatio > 100) {
          this.fbaJob.bubbleSplittingRatio = 100
          this.bubbleSplittingRatio = 100
        } else {
          this.bubbleSplittingRatio = this.fbaJob.bubbleSplittingRatio
        }
      }
    },
    calcEstVolumetricAndChargeWeight(booking = false, volumetricWeight) {
      if (!this.isFba) {
        return
      }
      const cubage = this.job.cubageContract * 1000000
      // 材积
      if (volumetricWeight && volumetricWeight > 0) {
        this.job.volumetricWeightContract = volumetricWeight
      } else {
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.fbaJob.chargingMethod) === 0) {
            this.job.volumetricWeightContract = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            this.job.volumetricWeightContract = (this.job.weightContract / 1000).toFixed(3)
          }
        }
      }
      // 计费重量
      const params = {
        fbaQuotation: this.fbaQuotation,
        chargingMethod: this.fbaJob.chargingMethod,
        quantity: this.job.quantityContract,
        weight: this.job.weightContract,
        cubage: this.job.cubageContract,
        volumetricWeight: this.job.volumetricWeightContract
      }
      const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
      if (!booking && this.job.quantityContract > 0 && this.job.weightContract > 0 && this.job.cubageContract > 0 && this.job.volumetricWeightContract > 0) {
        this.job.chargeWeight = Number(chargeWeight).toFixed(3)
      }
      if (!booking) {
        this.job.volumetricWeightContract = Number(this.job.volumetricWeightContract).toFixed(3)
        this.job.chargeWeight = Number(this.job.chargeWeight).toFixed(3)
      }
      this.job.chargeWeightBooking = this.job.chargeWeight
      this.job.volumetricWeightBooking = this.job.volumetricWeightContract
    },
    calcStationVolumetricAndChargeWeight(volumetricWeight) {
      if (!this.isFba) {
        return
      }
      const cubage = this.job.cubageStation * 1000000
      // 材积
      if (volumetricWeight && volumetricWeight > 0) {
        this.job.volumetricWeightStation = volumetricWeight
      } else {
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.fbaJob.chargingMethod) === 0) {
            this.job.volumetricWeightStation = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            this.job.volumetricWeightStation = (this.job.weightStation / 1000).toFixed(3)
          }
        }
      }
      // 计费重量
      const params = {
        fbaQuotation: this.fbaQuotation,
        chargingMethod: this.fbaJob.chargingMethod,
        quantity: this.job.quantityStation,
        weight: this.job.weightStation,
        cubage: this.job.cubageStation,
        volumetricWeight: this.job.volumetricWeightStation
      }
      const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
      if (this.job.quantityStation > 0 && this.job.weightStation > 0 && this.job.cubageStation > 0 && this.job.volumetricWeightStation > 0) {
        this.job.chargeWeightStation = Number(chargeWeight).toFixed(3)
      }
      this.job.volumetricWeightStation = Number(this.job.volumetricWeightStation).toFixed(3)
      this.job.chargeWeightStation = Number(this.job.chargeWeightStation).toFixed(3)
    },
    calcSigningVolumetricAndChargeWeight(volumetricWeight) {
      if (!this.isFba) {
        return
      }
      const cubage = this.job.cubageSigning * 1000000
      // 材积
      if (volumetricWeight && volumetricWeight > 0) {
        this.job.volumetricWeightSigning = volumetricWeight
      } else {
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.fbaJob.chargingMethod) === 0) {
            this.job.volumetricWeightSigning = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            this.job.volumetricWeightSigning = (this.job.weightSigning / 1000).toFixed(3)
          }
        }
      }
      // 计费重量
      const params = {
        fbaQuotation: this.fbaQuotation,
        chargingMethod: this.fbaJob.chargingMethod,
        quantity: this.job.quantitySigning,
        weight: this.job.weightSigning,
        cubage: this.job.cubageSigning,
        volumetricWeight: this.job.volumetricWeightSigning
      }
      const chargeWeightSigning = FbaQuotationUtil.calChargeWeight(params)
      if (this.job.quantitySigning > 0 && this.job.weightSigning > 0 && this.job.cubageSigning > 0 && this.job.volumetricWeightSigning > 0) {
        this.job.chargeWeightSigning = Number(chargeWeightSigning).toFixed(3)
      }
      this.job.volumetricWeightSigning = Number(this.job.volumetricWeightSigning).toFixed(3)
      this.job.chargeWeightSigning = Number(this.job.chargeWeightSigning).toFixed(3)
    },
    calcActVolumetricAndChargeWeight(doc = false, volumetricWeight) {
      if (!this.isFba) {
        return
      }
      const cubage = this.job.cubageActual * 1000000
      // 材积
      if (volumetricWeight && volumetricWeight > 0) {
        this.job.volumetricWeight = volumetricWeight
      } else {
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.fbaJob.chargingMethod) === 0) {
            this.job.volumetricWeight = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            this.job.volumetricWeight = (this.job.weightActual / 1000).toFixed(3)
          }
        }
      }
      // 计费重量
      const params = {
        fbaQuotation: this.fbaQuotation,
        chargingMethod: this.fbaJob.chargingMethod,
        quantity: this.job.quantityActual,
        weight: this.job.weightActual,
        cubage: this.job.cubageActual,
        volumetricWeight: this.job.volumetricWeight
      }
      const chargeWeight = FbaQuotationUtil.calChargeWeight(params)
      const refreshCharge = Number(chargeWeight) !== Number(this.job.cWeight)
      if (!doc && this.job.quantityActual > 0 && this.job.weightActual > 0 && this.job.cubageActual > 0 && this.job.volumetricWeight > 0) {
        this.job.cWeight = Number(chargeWeight).toFixed(3)
      }
      if (!doc) {
        this.job.volumetricWeight = Number(this.job.volumetricWeight).toFixed(3)
        this.job.cWeight = Number(this.job.cWeight).toFixed(3)
      }
      this.mawbDoc.cWeight = this.job.cWeight
      this.mawbDoc.volumetricWeight = this.job.volumetricWeight
      return refreshCharge
    },
    async changeVolumetricWeight() {
      if (this.isFba) {
        const refreshCharge = this.calcActVolumetricAndChargeWeight(false, this.job.volumetricWeight)
        if (refreshCharge) {
          await this.changeChargeWeight()
        }
      }
    },
    async changeChargeWeight() {
      if (this.job.customerId && this.fbaJob.serviceChannel && this.job.cWeight && this.job.cWeight > 0) {
        await this.$confirm(this.$t('FbaJob.changeChargeWeight'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          // 刷新费用
          this.refreshCharge()
        }).catch(() => {
        })
      }
    },
    preWarehousingChangeHandler() {
      const job = this.job
      const warehouse = job.warehouseInfo[0]
      if (warehouse) {
        warehouse.arriveDate = this.fbaJob.preWarehousingTime
        this.addWarehouseToModifiedSet(warehouse)
      }
    },
    addWarehouseToModifiedSet(warehouse) {
      const modifiedData = this.context.modifiedData
      modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
      if (!modifiedData.warehouseInfo.includes(warehouse)) {
        modifiedData.warehouseInfo.push(warehouse)
      }
    },
    // 目的地配送方式改变
    destinationDistributionChange() {
      if (this.fbaJob.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.DestinationDistribution')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.fbaJob.destinationDistribution = this.destinationDistribution
      } else {
        this.destinationDistribution = this.fbaJob.destinationDistribution
        this.syncConsigneeInfo()
      }
    },
    // 改变计费方式
    chargingMethodChange() {
      if (this.fbaJob.serviceChannel) {
        this.$alert(StrUtils.substitute(this.$t('FbaJob.channelInfoCannotChange'), this.$t('FbaJob.ChargingMethod')), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
        this.fbaJob.chargingMethod = this.chargingMethod
      } else {
        this.chargingMethod = this.fbaJob.chargingMethod
      }
    },
    // etd 修改事件
    async etdChange(value) {
      const oldValue = this.job.etd
      this.job.etd = value
      this.job.sailingDay = JobUtils.dateChange(this.job.etd)
      this.pm.etdChange(oldValue)
    },
    async etaChange(value) {
      this.job.eta = value
      this.job.etaSailingDay = JobUtils.dateChange(this.job.eta)
    },
    async atdChange(value) {
      const oldValue = this.job.atd
      this.job.atd = value
      this.job.atdSailingDay = JobUtils.dateChange(this.job.atd)
      if (Number(this.config.get('syncSignDateBl')) === 1) {
        const cargoDocList = await new AirExportJob(this.job).getAirCargoDoc()
        for (const cargoDoc of cargoDocList) {
          const allow = (cargoDoc.docType === CargoDocConsts.MAWB || cargoDoc.docType === CargoDocConsts.HAWB ||
            cargoDoc.docType === CargoDocConsts.HAWB2) && cargoDoc.state < 2 && (!cargoDoc.signDateBL ||
            (oldValue && dateCompare(DateUtils.formatStandardDate(cargoDoc.signDateBL), DateUtils.formatStandardDate(oldValue)) === 0))
          if (allow) {
            cargoDoc.signDateBL = this.job.atd
          }
        }
      }
      this.job.atdChanged = true
      if (this.job.usCustomsClearanceList && this.job.atd) {
        syncAtdInfoAE(this.job.usCustomsClearanceList, this.job.atd)
      }
    },
    async ataChange(value) {
      this.job.ata = value
      this.job.ataSailingDay = JobUtils.dateChange(this.job.ata)
    },
    onExChangeAgentChange(data) {
      this.job.exChangeAgent = data.value
      for (const item of this.job.dischargingTrucking) {
        item.exChangeAgent = data.value
      }
      this.context.modifiedData.dischargingTruckingInfo = this.job.dischargingTrucking
    },
    // 英制毛重变更
    async weightContractImperialChange() {
      // 录入英制毛重 计算公制毛重
      this.job.weightContract = await JobUtils.calculateWeight(this.job.weightContractImperial)
      // 执行公制变更方法
      await this.weightContractChange(false)
      // 用公制 算英制 是/
      this.job.chargeWeightImperial = await JobUtils.calculateWeight(this.job.chargeWeight, true)
    },
    async weightContractChange(needC = true) {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshWeightCharge(this.job, this.job.weightContract)
      }
      this.pm.weightCubageChangeHandler('weightContract')

      if (needC) {
        // 录入毛重 计算英制毛重
        this.job.weightContractImperial = await JobUtils.calculateWeight(this.job.weightContract, true)
        // 用公制 算英制 是/
        this.job.chargeWeightImperial = await JobUtils.calculateWeight(this.job.chargeWeight, true)
      }
    },
    // 英制毛重变更
    async weightStationImperialChange() {
      // 录入英制毛重 计算公制毛重
      this.job.weightStation = await JobUtils.calculateWeight(this.job.weightStationImperial)
      // 执行公制变更方法
      await this.weightStationChange(false)
    },
    async weightStationChange(needC = true) {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshWeightCharge(this.job, this.job.weightStation)
      }
      await this.pm.weightCubageChangeHandler('weightStation')

      if (needC) {
        // 录入毛重 计算英制毛重
        this.job.weightStationImperial = await JobUtils.calculateWeight(this.job.weightStation, true)
      }
      // 用公制 算英制 是/
      this.job.chargeWeightStationImperial = await JobUtils.calculateWeight(this.job.chargeWeightStation, true)
      await this.pm.changeChargeWeightStation()
    },
    // 英制毛重变更
    async weightSigningImperialChange(needC = true) {
      // 录入英制毛重 计算公制毛重
      this.job.weightSigning = await JobUtils.calculateWeight(this.job.weightSigningImperial)
      // 执行公制变更方法
      await this.weightSigningChange(false)
    },
    async weightSigningChange(needC = true) {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshWeightCharge(this.job, this.job.weightSigning)
      }
      await this.pm.weightCubageChangeHandler('weightSigning')

      if (needC) {
        // 录入毛重 计算英制毛重
        this.job.weightSigningImperial = await JobUtils.calculateWeight(this.job.weightSigning, true)
      }
      // 用公制 算英制 是/
      this.job.chargeWeightSigningImperial = await JobUtils.calculateWeight(this.job.chargeWeightSigning, true)
    },
    async refreshWeightCharge(job, weight) {
      const charges = ChargeUtils.weightChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.WeightChangeToRefreshCostBasedOnWeightPrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = weight
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
      ChargeUtils.wgttWeightChargesCanUpdate(job, weight, this.context)
    },
    async cubAgeContractImperialChange() {
      // 录入英制毛重 计算公制毛重
      this.job.cubageContract = await JobUtils.calculateCubAge(this.job.cubAgeContractImperial)
      // 执行公制变更方法 获取计费重
      await this.cubageContractChange(false)
    },
    async cubageContractChange(needC = true) {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshCubageCharge(this.job, this.job.cubageContract)
      }
      this.pm.weightCubageChangeHandler('cubageContract')

      if (needC) {
        // 录入毛重 计算英制毛重
        this.job.cubAgeContractImperial = await JobUtils.calculateCubAge(this.job.cubageContract, true)
      }
      // 用公制 算英制 是/
      this.job.chargeWeightImperial = await JobUtils.calculateWeight(this.job.chargeWeight, true)
    },
    async cubAgeStationImperialChange() {
      // 录入英制毛重 计算公制毛重
      this.job.cubageStation = await JobUtils.calculateCubAge(this.job.cubAgeStationImperial)
      // 执行公制变更方法 获取计费重
      await this.cubageStationChange(false)
    },
    async cubageStationChange(needC = true) {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshCubageCharge(this.job, this.job.cubageStation)
      }
      await this.pm.weightCubageChangeHandler('cubageStation')
      if (needC) {
        // 录入毛重 计算英制毛重
        this.job.cubAgeStationImperial = await JobUtils.calculateCubAge(this.job.cubageStation, true)
      }
      // 用公制 算英制 是/
      this.job.chargeWeightStationImperial = await JobUtils.calculateWeight(this.job.chargeWeightStation, true)
      await this.pm.changeChargeWeightStation()
    },
    async cubAgeSigningImperialChange() {
      // 录入英制毛重 计算公制毛重
      this.job.cubageSigning = await JobUtils.calculateCubAge(this.job.cubAgeSigningImperial)
      // 执行公制变更方法 获取计费重
      await this.cubageSigningChange(false)
    },
    async cubageSigningChange(needC = true) {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshCubageCharge(this.job, this.job.cubageSigning)
      }
      await this.pm.weightCubageChangeHandler('cubageSigning')
      if (needC) {
        // 录入毛重 计算英制毛重
        this.job.cubAgeSigningImperial = await JobUtils.calculateCubAge(this.job.cubageSigning, true)
      }
      // 用公制 算英制 是/
      this.job.chargeWeightSigningImperial = await JobUtils.calculateWeight(this.job.chargeWeightSigning, true)
    },
    async refreshCubageCharge(job, cubage) {
      const charges = await ChargeUtils.cubageChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.CubageChangeToRefreshCostBasedOnCubagePrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = cubage
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
    },
    async quantityActualChange() {
      if (this.isFba) {
        const refreshCharge = this.calcActVolumetricAndChargeWeight()
        if (refreshCharge) {
          await this.changeChargeWeight()
        }
      }
    },
    async weightActualImperialChange() {
      // 录入英制毛重 计算公制毛重
      this.job.weightActual = await JobUtils.calculateWeight(this.job.weightActualImperial)
      // 执行公制变更方法
      await this.weightActualChange(false)
    },
    async weightActualChange(needC = true) {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.refreshWeightCharge(this.job, this.job.weightActual)
      }
      // 这里会同步更新制单
      await this.pm.weightCubageChangeHandler('weightActual')
      if (needC) {
        // 录入毛重 计算英制毛重
        this.job.weightActualImperial = await JobUtils.calculateWeight(this.job.weightActual, true)
      }
      // 用公制 算英制 是/
      this.job.cWeightImperial = await JobUtils.calculateWeight(this.job.cWeight, true)
      // 同时计算制单英制
      await this.pm.doWeightCubAgeChangeHandler('weightMBL')
      if (!this.job.multipleDischargingPickups && this.job.dischargingTrucking && this.job.dischargingTrucking.length > 0) {
        this.job.dischargingTrucking[0].weight = this.job.weightActual || 0
        this.context.modifiedData.dischargingTruckingInfo = this.job.dischargingTrucking
      }
      if (this.isFba) {
        const refreshCharge = this.calcActVolumetricAndChargeWeight()
        if (refreshCharge) {
          await this.changeChargeWeight()
        }
      }
    },
    async cubAgeActualImperialChange() {
      // 录入英制毛重 计算公制毛重
      this.job.cubageActual = await JobUtils.calculateCubAge(this.job.cubAgeActualImperial)
      // 执行公制变更方法
      await this.cubageActualChange(false)
    },
    async cubageActualChange(needC = true) {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.refreshCubageCharge(this.job, this.job.cubageActual)
      }
      // 这里会算下制单
      await this.pm.weightCubageChangeHandler('cubageActual')
      if (needC) {
        // 录入毛重 计算英制毛重
        this.job.cubAgeActualImperial = await JobUtils.calculateCubAge(this.job.cubageActual, true)
      }
      // 用公制 算英制 是/
      this.job.cWeightImperial = await JobUtils.calculateWeight(this.job.cWeight, true)
      // 同时算下制单英制
      await this.pm.doWeightCubAgeChangeHandler('cubageMBL')
      if (!this.job.multipleDischargingPickups && this.job.dischargingTrucking && this.job.dischargingTrucking.length > 0) {
        this.job.dischargingTrucking[0].cubage = this.job.cubageActual || 0
        this.context.modifiedData.dischargingTruckingInfo = this.job.dischargingTrucking
      }
      if (this.isFba) {
        const refreshCharge = this.calcActVolumetricAndChargeWeight()
        if (refreshCharge) {
          await this.changeChargeWeight()
        }
      }
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      params.JOB_UUID = this.job.uuid
      params.category = 'AEBOOKING'
      params.ctx = new AirExportJob(this.job)
      return params
    },
    endTabHandler() {
      return this.pm.fillModel(false)
    },
    async getSubmitData() {
      await this.validateForm()
      await this.pm.fillModel(true)
      const job = { ...this.job }
      if (job.mbl) {
        job.mbl = job.mbl.trim()
      }
      if (job.handlingInformation) {
        job.handlingInformation = job.handlingInformationCode // 将code保存到数据库
      }
      const airCargoDoc = []
      if (this.mawbDoc) {
        if (!this.job.uuid) {
          if (Number(this.config.get('syncSignDateBl')) === 1) {
            this.mawbDoc.signDateBL = this.job.atd
          } else {
            this.mawbDoc.signDateBL = this.job.etd
          }
        }
        airCargoDoc.push(this.mawbDoc)
      }
      if (this.hawbDoc) {
        if (!this.job.uuid) {
          if (Number(this.config.get('syncSignDateBl')) === 1) {
            this.hawbDoc.signDateBL = this.job.atd
          } else {
            this.hawbDoc.signDateBL = this.job.etd
          }
        }
        airCargoDoc.push(this.hawbDoc)
      }
      // fba业务
      const fbaJob = this.isFba ? { ...this.fbaJob } : null

      let unitLoadDeviceUsages = []
      if (job.lclMasterUuid && (!job.unitLoadDevices ||
        job.unitLoadDevices.length <= 0) && job.unitLoadDeviceUsages && job.unitLoadDeviceUsages.length > 0) {
        unitLoadDeviceUsages = job.unitLoadDeviceUsages
        for (const unitLoadDeviceUsage of unitLoadDeviceUsages) {
          if (unitLoadDeviceUsage.unitLoadDevice && unitLoadDeviceUsage.unitLoadDevice.unitLoadDeviceUsage === '') {
            unitLoadDeviceUsage.unitLoadDevice.unitLoadDeviceUsage = []
          }
        }
      }
      const submitData = {
        job,
        airCargoDoc,
        fbaJob, // fba业务
        airUld: job.airUld,
        delAirUldUuids: job.delAirUldUuids,
        unitLoadDevices: job.unitLoadDevices, // this.form.containers.filter(p => p.isDirty === true), // 实际件毛体 更改影响装箱数据未标记isDirty，后续根据需要再处理
        unitLoadDeviceUsages: unitLoadDeviceUsages,
        delUnitLoadDeviceUuids: job.delUnitLoadDeviceUuids, // 删除的箱子uuid
        delUnitLoadDeviceUsageUuids: job.delUnitLoadDeviceUsageUuids // 删除的装箱uuid
      }
      if (this.loadingPortChanged || this.job.ataChanged) {
        submitData.usCustomsClearanceList = this.job.usCustomsClearanceList
      }
      return submitData
    },
    async validateForm() {
      const form = this.job
      if (form.customerId < 1) {
        throw new TabError(this.$t('Message.ConsignationCompanyCannotBeNull'), 'basicTab')
      }
      await JobUtils.checkCustomerBranchScope(form, 'basicTab')
      await SecurityUtil.companyisActive(this.$t('SeaExport.Customer'), form.customerId, 'basicTab')
      if (!form.loadingPortCode) {
        throw new TabError(this.$t('Message.PortOfLoadingPortCannotBeNull'), 'basicTab')
      }
      if (!form.destinationPortCode) {
        throw new TabError(this.$t('Message.PortOfDestinationCannotBeNull'), 'basicTab')
      }
      if (!form.etd) {
        throw new TabError(this.$t('Message.DateOfDepartureCannotBeNull'), 'basicTab')
      }
      if (!form.opDepartment) {
        throw new TabError(this.$t('SeaExport.OperationDepartmentCannotBeEmpty'), 'basicTab')
      }
      if (!form.op && form.jobState !== -1) {
        throw new TabError(this.$t('queryJob.PleaseEnterOperatorInformation'), 'basicTab')
      }
      // eslint-disable-next-line no-undef
      if (!form.express && (form.bookingTerm === BookingTerm.DB_BOOKING_TYPE.code || Number(this.config.get('AEAllowInputMBL')) === 1) &&
       form.mbl && !AirExportUtils.validateMAWBNumIgnoreZeroOrThree(form.mbl)) {
        throw new TabError(this.$t('queryJob.TheIsIllegalPleaseEnter'), 'basicTab')
      }
      if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
        throw new TabError(this.$t('queryJob.PleaseTheDesignatedShippingAgent'), 'basicTab')
      }
      if (form.cargoSource === 'SC' || parseInt(this.config.get('NorminationJobSaleType')) === 1) {
        if (!form.sales || form.sales === 0) {
          throw new TabError(this.$t('Message.SalesCannotBeNull'), 'basicTab')
        }
        if (!form.salesOffice || form.salesOffice === 0) {
          throw new TabError(this.$t('Message.SalesBranchCompanyIsNullPleaseReSelectSales'), 'basicTab')
        }
        if (!form.salesDepartment || form.salesDepartment === 0) {
          throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'basicTab')
        }
      } else {
        if (form.sales && !form.salesDepartment) {
          throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'basicTab')
        }
      }
      if (form.localAgent > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.LocalAgent'), form.localAgent, 'basicTab')
      }
      if (form.destinationAgent > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.DestinationAgent'), form.destinationAgent, 'basicTab', 'englishName')
      }
      if (form.bookingAgent > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.BookingAgent'), form.bookingAgent, 'basicTab')
      }
      if (form.carrierId > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.AirlineCompany'), form.carrierId, 'basicTab')
      }
      if (form.cargoSource === 'NC' && form.designationAgent > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.NominatedAgent'), form.designationAgent, 'basicTab')
      }
      if (form.customerId > 0) {
        const c = await Company.getCompanyById(form.customerId)
        if (!c || !c.customer || !c.active) {
          const message = this.$t('Message.CustomerTipMessage', c ? [c.chineseName] : [''])
          throw new TabError(message, 'basicTab')
        }
        if (!SecurityUtil.customerIsOwn(form.customerId) && !form.uuid) {
          throw new TabError(this.$t('CargoMsg.Cargo_CustomerNotOwn'), 'basicTab')
        }
      }

      // 空运头程 保存校验
      if (this.isFba && this.fbaJob) {
        if (!this.fbaJob.preWarehousingTime) {
          throw new TabError('预计入仓/货好时间不能为空！', 'basicTab')
        }
        if (!this.fbaJob.warehouseCode) {
          throw new TabError(this.$t('AirExport.DestinationCannotBeEmpty'), 'basicTab')
        }
        if (!this.fbaJob.country) {
          throw new TabError(this.$t('AirExport.DestinationCountryCannotBeEmpty'), 'basicTab')
        }
        if (!this.fbaJob.zipCode) {
          throw new TabError(this.$t('AirExport.ZipCodeCannotBeEmpty'), 'basicTab')
        }
        if (!this.fbaJob.chargingMethod && this.fbaJob.chargingMethod !== 0) {
          throw new TabError(this.$t('FbaJob.ChargingMethod') + this.$t('AirExport.CannotBeEmpty'), 'basicTab')
        }
      }
      if (UnitLoadDeviceUtil.checkNoDuplationSeaEQ(form)) {
        throw new TabError(this.$t('SeaExport.RepeatUldType'), 'basicTab')
      }
      const airInput = UnitLoadDeviceUtil.checkInput(form)
      if (airInput) {
        throw new TabError(airInput, 'basicTab')
      }
      // 中邮定制字段 保存校验
      if (this.isZY && !form.saleProductCode) {
        throw new TabError(this.$t('Message.SaleProductCodeCannotBeNull'), 'basicTab')
      }
      if (this.isZY && !form.fullOrInside) {
        throw new TabError(this.$t('Message.FullOrInsideCannotBeNull'), 'basicTab')
      }
    },
    selectMAWB() {
      let location = null
      if (!this.isFba) {
        location = LOG_AE_AIR_BOOKING.code
      }
      selectMawb({ jobKey: this.job.uuid, mawbKey: this.mawbDetail.uuid, location: location }).then(res => {
        if (res.data) { // 调用后端方法，修改job属性，返回后更新对应的修改字段
          this.job.mbl = res.data.mbl
          this.job.express = res.data.express
          this.job.version = res.data.version
          this.pm.checkMAWBRelationState()
        }
      })
    },
    newConsole() {
      let location = null
      if (!this.isFba) {
        location = LOG_AE_AIR_BOOKING.code
      }
      newConsole({ jobKey: this.job.uuid, mawbKey: this.mawbDetail.uuid, location: location }).then(res => {
        if (res.data) { // 调用后端方法，修改job属性，返回后更新对应的修改字段
          this.job.mbl = res.data.mbl
          this.job.express = res.data.express
          this.job.version = res.data.version
          this.pm.checkMAWBRelationState()
        }
      })
    },
    attachMAWB() {
      if (!this.mawbDetail || !this.mawbDetail.job) {
        this.$message.warning('无效的主单号，不能绑定!')
        return
      } else {
        const fields = AirExportUtils.getDiffFields(this.mawbDetail.job, this.job)
        if (fields && fields.length > 0) {
          this.$confirm(fields.join(',') + '\\n' + this.$t('queryJob.TheseWillBeSetJoin'), this.$t('Message.Confirm'), {
            confirmButtonText: this.view.$t('constant.yes'),
            cancelButtonText: this.view.$t('constant.no'),
            type: 'info'
          }).then(() => {
            this.doAttach()
          }).catch(() => false)
        } else {
          this.doAttach()
        }
      }
    },
    doAttach() {
      let location = null
      if (!this.isFba) {
        location = LOG_AE_AIR_BOOKING.code
      }
      attach({ jobKey: this.job.uuid, masterKey: this.mawbDetail.job.uuid, location: location }).then(res => {
        if (res.data) { // 调用后端方法，修改job属性，返回后更新对应的修改字段
          this.job.version = res.data.version
          this.job.lclMasterUuid = res.data.lclMasterUuid
          this.job.mbl = res.data.mbl
          this.job.destinationAgent = res.data.destinationAgent
          this.job.loadingPortCode = res.data.loadingPortCode
          this.job.bookingAgent = res.data.bookingAgent
          this.job.carrierId = res.data.carrierId
          this.job.etd = res.data.etd
          this.job.eta = res.data.eta
          this.job.bookingTerm = res.data.bookingTerm
          this.job.voyageFlight = res.data.voyageFlight
          this.job.paymentTermMBL = res.data.paymentTermMBL
          this.pm.checkMAWBRelationState()
        }
      })
    },
    executeTask() {
      switch (this.taskType) {
        case 1:
          this.selectMAWB()
          break
        case 2:
          this.newConsole()
          break
        case 3:
          this.attachMAWB()
          break
        case 4:
          break
      }
      this.taskType = -1
      if (this.allocate) {
        this.allocate = false
        autoAllocateCargo(this.job.uuid).then(res => {
          this.refreshWarehouseInQWC(res.data)
        })
      }
      // 保存客户发运信息
      this.addrPM.job = this.job
      this.addrPM.isPortFilter = true
      this.addrPM.shipperCodeField = ''
      this.addrPM.shipperField = 'shipperLine'
      this.addrPM.consigneeCodeField = ''
      this.addrPM.consigneeField = 'consigneeLine'
      this.addrPM.notifyCodeField = ''
      this.addrPM.notifyField = 'notifyLine'
      this.addrPM.viewFromBasic = true
      if (parseInt(this.config.get('syncMailingAddress')) === 1) {
        this.addrPM.saveCheck()
      }
    },
    async refreshWarehouseInQWC(list) {
      let totalQuantity = 0
      let totalWeight = 0
      let totalCubage = 0
      const cWeightIsCeil = Number(this.config.get('AEcWeightCeil')) // 计费重量是否取整
      for (const warehouse of list) {
        totalQuantity += warehouse.quantitySum || 0
        totalCubage += warehouse.cubageSum || 0
        totalWeight += warehouse.weightSum || 0
      }
      if (this.job.quantityActual !== totalQuantity) {
        this.job.quantityActual = totalQuantity
        if (!this.job.multipleDischargingPickups && this.job.dischargingTrucking && this.job.dischargingTrucking.length > 0) {
          this.job.dischargingTrucking[0].quantity = this.job.quantity || 0
          this.context.modifiedData.dischargingTruckingInfo = this.job.dischargingTrucking
        }
      }
      if (this.job.weightActual !== totalWeight) {
        this.job.weightActual = totalWeight
        if (!this.job.multipleDischargingPickups && this.job.dischargingTrucking && this.job.dischargingTrucking.length > 0) {
          this.job.dischargingTrucking[0].weight = this.job.weightActual || 0
          this.context.modifiedData.dischargingTruckingInfo = this.job.dischargingTrucking
        }
      }
      if (this.job.cubageActual !== totalCubage) {
        this.job.cubageActual = totalCubage
        if (!this.job.multipleDischargingPickups && this.job.dischargingTrucking && this.job.dischargingTrucking.length > 0) {
          this.job.dischargingTrucking[0].cubage = this.job.cubageActual || 0
          this.context.modifiedData.dischargingTruckingInfo = this.job.dischargingTrucking
        }
      }
      this.job.cWeight = JobUtils.calcProportion(this.job.pbProportion2, this.job.weightActual, this.job.cubageActual, true, cWeightIsCeil, this.splitBubbleCollectionFormat)
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObj = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0
      }
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
      this.advanceTextDialog.visible = true
      // 代表是从handlingInformation这个点过来的 弹框不可编辑
      if (title === this.$t('SeaExport.handlingInformation')) {
        this.advanceTextDialog.hasHandlingInformation = true
      } else {
        this.advanceTextDialog.hasHandlingInformation = false
      }
      if (title === this.$t('SeaExport.EnglishDescriptionOfGoods') || title === this.$t('SeaExport.Marks') || title === this.$t('SeaExport.handlingInformation')) {
        this.showMarkOrCargoEnglishNameDialog = true
      }
    },
    finishAdvanceText() {
      const title = this.advanceTextDialog.title
      if (title === this.$t('SeaExport.Shipper') || title === this.$t('SeaExport.Consignee') || title === this.$t('SeaExport.NotifyParty')) { // 书法通最大行数不能超过6行
        const text = this.advanceTextDialog.value
        if (text) {
          const maxRows = (text.split('\n').length) - 1
          if (maxRows > 7) {
            this.$message.warning(this.$t('queryJob.TheNotExceed7Lines'))
            return
          }
        }
      }
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
      this.$nextTick(() => {
        const shipper = from.startsWith('shipperLine')
        const consignee = from.startsWith('consigneeLine')
        const notify = from.startsWith('notifyLine')
        if (this.syncCustomerShippingInfoBothBolAndBasicTabAll) {
          this.pm.syncDocSft(shipper, consignee, notify)
        }
      })
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.job['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.job['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.job['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.job['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.job['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.job['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['notifyLine' + i] = ''
      }
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.job['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.job['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.job['notifyCode'] = data.notifyCode || ''
      }
    },
    showWarehouseDialog() {
      if (!this.viewStatus) {
        this.warehouseDialog.visible = true
        this.warehouseDialog.job = this.job
      }
    },
    warehouseCommitCallback(data) {
      this.allocate = true
      this.job.ownWarehouse = data.ownWarehouse
      this.job.takePhotos = data.takePhotos
      this.job.documentsAttached = data.documentsAttached
      this.job.warehouseNo = data.warehouseNo
      this.job.estimatedDateOfWarehousinge = data.estimatedDateOfWarehousinge
      this.job.otherWarehouseNotes = data.otherWarehouseNotes
      this.warehouseDialog.visible = false
    },
    // 代码检索
    codeSearch() {
      this.billAddressDialog.job = this.job
      this.billAddressDialog.params.isPortFilter = false
      this.billAddressDialog.params.shipperCode = ''
      this.billAddressDialog.params.consigneeCode = ''
      this.billAddressDialog.params.notifyCode = ''
      this.billAddressDialog.params.shipperField = 'txtshipperLine'
      this.billAddressDialog.params.consigneeField = 'txtconsigneeLine'
      this.billAddressDialog.params.notifyField = 'txtnotifyLine'
      this.billAddressDialog.params.mbl = false
      this.billAddressDialog.visible = true
    },
    // 中转信息回调函数
    transitPortDialogCallback() {
      if (this.mawbDoc && this.mawbDoc.state < 2) {
        new AirCargoDoc(this.mawbDoc).copyTransitPortInfo(this.mawbDoc, this.job)
      }
      if (this.hawbDoc && this.hawbDoc.state < 2) {
        new AirCargoDoc(this.hawbDoc).copyTransitPortInfo(this.hawbDoc, this.job)
      }
    },
    async mblCheckHandler(flg = false) {
      if (flg) {
        await this.mblChangeCallback()
      }
      const mblPrefix = this.$refs.mawbNoInput.prefix.trim()
      if (mblPrefix) {
        const airline = await this.getPartnerAirline(this.job.carrierId)
        const mawbprefix = airline.mawbprefix.trim()
        if (mawbprefix && mawbprefix !== mblPrefix) {
          this.$message.warning(this.$t('queryJob.EnteredXNotMatchAirlinePrefix', [mblPrefix]))
        }
        this.mblChange()
      }
    },
    mblChangeCallback() {
      const mblPrefix = this.$refs.mawbNoInput.prefix.trim()
      if (mblPrefix) {
        const company = JobUtils.getAirLineCompanyByMblPrefixAndOfficeId(mblPrefix, this.$store.getters.currentOfficeId)
        if (company) {
          this.pm.airlineCompanyChangeHandler(company.cmpIdx)
        }
      }
    },
    // 获取合作伙伴航空公司信息
    async getPartnerAirline(cmpIdx) {
      const airline = { cmpIdx, airlineCode: '', mawbprefix: '' }
      const cmp = Company.getCompanyByIdSync(cmpIdx)
      if (cmp) {
        await getAirlineList({ companyUuid: cmp.uuid }).then(res => {
          if (res.data.list.length > 0) {
            Object.assign(airline, res.data.list[0])
          }
        })
      }
      return airline
    },
    mblChangeEvent(text) {
      if (!this.job.express) {
        if (!text || text.length === 0 || text.length === 11) {
          this.pm.checkMAWBRelationState()
        }
      }
    },
    async airlineCompanyCheckHandler(carrierId) {
      if (carrierId > 0) {
        await this.voyageFlightCheckHandler()
        if (!this.job.express) {
          setTimeout(() => {
            this.mblCheckHandler(false)
          }, 100)
        }
      }
    },
    async voyageFlightCheckHandler() {
      if (this.job.voyageFlight) {
        this.job.voyageFlight = this.job.voyageFlight.trim().toUpperCase()
        const voyageFlight = this.job.voyageFlight
        const airline = await this.getPartnerAirline(this.job.carrierId)
        const airlineCode = airline.airlineCode.trim()
        if (airlineCode && airlineCode !== voyageFlight.substring(0, 2)) {
          this.$message.warning(this.$t('queryJob.EnteredXNotMatchAirlineCode', [voyageFlight]))
        }
      }
    },
    async sellingOrBuyingChangeHandler(isShowCreatedCharge = true, type = 0) {
      const job = this.job
      if (job.charges && job.charges.length > 0) {
        // 已经有费用来源为空运费,不在新增费用
        const index = job.charges.findIndex(p => p.chargeSource === CHARGE_BUYING_AND_SELLING_PRICE.code)
        if (index > -1) {
          let msg = ''
          if (type === 1) {
            msg = this.$t('Message.CurrencyChangeConfirm')
          } else if (type === 2) {
            msg = this.$t('Message.PriceTypeChangeConfirm')
          } else if (type === 3) {
            msg = this.$t('Message.PriceUpdateConfirm')
          }
          await this.pm.changeChargeWeightStation(msg)
        } else {
          if (isShowCreatedCharge) {
            ChargeUtils.sellingOrBuyingTipHandler(this.job, this.job.cWeight, this.job.chargeWeightBooking, this)
          }
        }
      } else {
        if (isShowCreatedCharge) {
          ChargeUtils.sellingOrBuyingTipHandler(this.job, this.job.cWeight, this.job.chargeWeightBooking, this)
        }
      }
    },
    addedServiceChangeHandler() {
      this.fbaJob.valueAddedServices = this.selectedLocalAddedService.concat(this.selectedPodAddedService).join(',')
    },
    singleAddedServiceChangeHandler(val, item) {
      this.job[item.code] = val
      // 需特殊处理的增值服务，如新增页签
      // 报关
      if (item.code === 'customs') {
        this.job.customsBroker = val ? this.job.customsBroker : 0
      }
    },
    expressChangeHandler() {
      if (!this.job.express) {
        this.job.mbl = null
      }
      this.pm.checkMAWBRelationState()
    },
    // 客户属性过滤
    fbaCustomerIdFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customer && item.fba && item.active
    },
    fbaCodeSearchBtn() {
      if (!this.fbaJob || !this.fbaJob.customerId || Number(this.fbaJob.customerId) <= 0) {
        this.$message.warning('请先选择委托单位。')
        return
      }
      this.fbaBillAddressDialog.visible = true
    },
    // fba收发通地址
    fbaCodeSearchCallback(data) {
      if (data.shipperInfo) {
        const curInfo = JobUtils.fbaHandleSft(data.shipperInfo, 'shipper')
        this.splitShipperLine(curInfo)
      }
      if (data.consigneeInfo) {
        const curInfo = JobUtils.fbaHandleSft(data.consigneeInfo, 'consignee')
        this.splitConsigneeLine(curInfo)
      }
      if (data.notifyInfo) {
        const curInfo = JobUtils.fbaHandleSft(data.notifyInfo, 'notify')
        this.splitNotifyLine(curInfo)
      }
    },
    // 修改过预计入库时间加个标识
    changeEstimatedDateOfWarehousinge() {
      this.job.estimatedDateOfWarehousingeDirty = true
    },
    // 修改过预计出库时间加个标识
    changeEstimatedDeliveryTime() {
      this.job.estimatedDeliveryTimeDirty = true
    },
    cargoTerminalOperationChange(p) {
      this.job.cargoTerminalOperation = p.value
      if (!this.job.cargoTerminalOperation) {
        this.job.estimatedDeliveryDate = null
      }
    },
    mblChange() {
      if (this.job.mbl === this.oldMbl) {
        return
      }
      this.oldMbl = this.job.mbl
      JobUtils.mblChange(this.job, 'mbl', this)
    },
    async changeProject() {
      if (this.isProjectLinkedCustomer) {
        const company = await getPartnerByPoNo(this.job.poNo).then(res => {
          return res.data
        })
        if (company && this.job.customerId !== company.cmpIdx && company.active) {
          await this.customerIdChange2ContractHandler(company)
        }
      }
    },
    clearPoNo() {
      if (this.isProjectLinkedCustomer) {
        this.job.poNo = ''
        this.job.projectName = ''
      }
    },
    onPbProportionFocus() {
      if (this.pbProportionCheck) {
        return
      }
      this.pbProportionCheck = true
      if (!this.job.pbProportion) {
        return
      }
      const state = CommonState.getStateByCode(SPLIT_BUBBLE_COLLECT_ITEMS, this.job.pbProportion)
      if (!state) {
        this.job.pbProportion = 0
        this.pm.weightCubageChangeHandler('pbProportion')
      }
    },
    onPbProportion2Focus() {
      if (this.pbProportion2Check) {
        return
      }
      this.pbProportion2Check = true
      if (!this.job.pbProportion2) {
        return
      }
      const state2 = CommonState.getStateByCode(SPLIT_BUBBLE_COLLECT_ITEMS, this.job.pbProportion2)
      if (!state2) {
        this.job.pbProportion2 = 0
        this.pm.weightCubageChangeHandler('pbProportion2')
      }
    },
    closeAdvanceText() {
      this.showMarkOrCargoEnglishNameDialog = false
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.job.opOffice = val
    },
    onCargoTypeChagne() {
      JobUtils.matchUserPortConfig(this, this.job)
    },
    commissionDimensionsChange(type) {
      if (!this.isEdit) {
        return
      }
      this.dimensionsDialog.visible = true
      this.dimensionsDialog.type = type
    },
    async sizeDataHandler(e) {
      // 委托数据填充
      if (e && e.dimension && this.dimensionsDialog.type === 1) {
        this.job.commissionDimensions = e.dimension
        this.job.quantityContract = e.quantitySum
        this.job.cubAgeContractImperial = e.cubAgeImperial
        this.job.cubageContract = e.cubAgeSum
        this.pm.weightCubageChangeHandler('cubageContract')
      }
      // 订舱
      if (e && e.dimension && this.dimensionsDialog.type === 2) {
        this.job.measurements = e.dimension
        this.job.quantityBooking = e.quantitySum
        this.job.cubAgeBookingImperial = e.cubAgeImperial
        this.job.cubageBooking = e.cubAgeSum
        this.pm.weightCubageChangeHandler('cubageBooking')
        this.pm.weightCubageChangeHandler('quantityBooking')
        this.pm.weightCubageChangeHandler('measurements')
      }
      // 前置仓（实际）
      if (e && e.dimension && this.dimensionsDialog.type === 3) {
        this.job.dimensionsActual = e.dimension
        this.job.quantityActual = e.quantitySum
        this.job.cubAgeActualImperial = e.cubAgeImperial
        this.job.cubageActual = e.cubAgeSum
        this.pm.weightCubageChangeHandler('cubageActual')
        this.pm.weightCubageChangeHandler('quantityActual')
        this.pm.weightCubageChangeHandler('dimensionsActual')
      }
      // 货站
      if (e && e.dimension && this.dimensionsDialog.type === 4) {
        this.job.freightStationDimensions = e.dimension
        this.job.quantityStation = e.quantitySum
        this.job.cubAgeStationImperial = e.cubAgeImperial
        this.job.cubageStation = e.cubAgeSum
        this.pm.weightCubageChangeHandler('cubageStation')
        this.pm.weightCubageChangeHandler('quantityStation')
        this.pm.weightCubageChangeHandler('freightStationDimensions')
      }
      // 签单
      if (e && e.dimension && this.dimensionsDialog.type === 5) {
        this.job.dimensionsSigning = e.dimension
        this.job.quantitySigning = e.quantitySum
        this.job.cubAgeSigningImperial = e.cubAgeImperial
        this.job.cubageSigning = e.cubAgeSum
        this.pm.weightCubageChangeHandler('cubageSigning')
        this.pm.weightCubageChangeHandler('quantitySigning')
        this.pm.weightCubageChangeHandler('dimensionsSigning')
      }
      // 制单
      if (e && e.dimension && this.dimensionsDialog.type === 6) {
        this.job.docDimensions = e.dimension
        this.mawbDoc.quantity = e.quantitySum
        this.mawbDoc.cubAgeImperial = e.cubAgeImperial
        this.mawbDoc.cubage = e.cubAgeSum
        this.pm.weightCubageChangeHandler('cubageMBL')
      }
    },
    // 合同规则相关字段切换时调用刷新【客户、指定货代理】信控信息
    contractRuleFieldChange(customerId, designationAgent) {
      this.pm.checkCredit()
      if (this.creditOpen) {
        // this.pm.checkCreditByCompany(customerId, 1)
        // this.pm.checkCreditByCompany(designationAgent, 2)
        this.pm.checkNewJobCreditInfo()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#app .ae-basic-from {
  .fit-content {
    .form-column {
      width: auto;
    }
  }
}
::v-deep .el-date-editor--datetime.is-disabled{
  input::placeholder{
    color: rgb(153, 153, 153) !important;
  }
}
.goods-info{
  /deep/ .goods-info-item{
    .el-form-item__content{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .el-input{
        width: 190px;
        margin-left: 12px;
        text-align: right !important;
      }
    }
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea{
    border: 1px solid red !important;
  }
}
</style>
